import { Language } from "@mui/icons-material";
import { Trans } from 'react-i18next';


// API Endpoints
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

export const API_ENDPOINTS = {
  LOGIN: `${API_BASE_URL}/auth/login`,
  REGISTER: `${API_BASE_URL}/auth/register`,
  USERS: `${API_BASE_URL}/users`,
  PRODUCTS: `${API_BASE_URL}/products`,
  ORDERS: `${API_BASE_URL}/orders`,
};

// App Configuration
export const APP_CONFIG = {
  APP_NAME: 'MyReactApp',
  ITEMS_PER_PAGE: 10,
  SUPPORTED_LANGUAGES: ['en', 'es', 'fr', 'de'],
};




// Routes
export const ROUTES = {
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  RESET_PASSWORD_WITH_TOKEN: '/reset-password/:token',
  PAGE_NOT_FOUND: '*',


  VERIFY_EMAIL: '/verify-email',
  ACCEPT_EULA: '/accept-eula',

  HOME: '/',
  HOME_ALIAS: '/home',

  MACHINES: '/machines',
  MACHINE_DETAILS_PATTERN: '/machines/:machineID',
  PRODUCT_DETAILS_PATTERN: '/machines/:machineID/:productid',

  MACHINE_DETAILS: (machineID) => `/machines/${machineID}`,
  PRODUCT_DETAILS: (machineID, productid) => `/machines/${machineID}/${productid}`,
  RECOMMENDATIONS: '/my-lists',
  CCR_RECOMMENDATIONS: '/ccr-recommendations',
  CART: '/cart',
  CHECKOUT: '/checkout',

  FINDER: '/finder',

  ORDER_RECEIVED: '/order-received/:orderKey',
  ORDER_ERROR: '/order-error/:orderKey',
  ORDER_HISTORY: '/order-history',
  ORDER_HISTORY_ES: '/bestellungen',
  ORDER_PRODUCT_DETAILS: '/order-history/:machineID/:productID',
  ORDERS_DETAILS: '/order-history/:machineID',
  TRACK_ORDER: '/track-order',

  SETTINGS: '/settings',
  PROFILE: '/profile',
  PROFILE_ES: '/perfil',
  ADMIN: '/admin',
  RSPL: '/rspl',
  DOCUMENT: '/documentation',
  DOCUMENT_DETAILS: '/documentation/:machine_id',
  REQUESTS: '/requests',
  SUPPORT: '/support',
  SUPPORT_ES: '/soporte',
  SAVED_FOR_LATER: '/saved_for_later',
  NOTIFICATIONS: '/notifications',
  ANALYTICS: '/analytics',
  USER_ANALYTICS:'/analytics/user',
  SERVICES: '/services',

  REPORTS: '/reports',
  SEARCH_RESULTS: '/search-results',
  LOGOUT: '/logout',
  LOGOUT_ES: '/cerrar-sesión',

  HOME_ALIA: '/home',
  MACHINE: '/machines',
  DOCUMENTS: '/documentation',

  MODEL_VIEWER: '/model-viewer',
  TWOD_MODEL_VIEWER: '/2d-model-viewer',
  HTML_MODEL_VIEWER: '/html-model-viewer',
  PUBLIC_MODEL_CHECK: '/public/model-check',

  MARKDOWN:'/help'


};

export const SITE_MANAGEMENT = {
  ADDRESS_SAVED: 'Address Saved',
  COMPANY_WEBSITE: 'Company Website',
  STREET2: 'STREET_2',
  STREET3: 'STREET_3',
  IS_ALREADY_PROVISIONED_FOR_THIS_SITE_PLEASE_REMOVE_OR_EDIT_THE_EXISTING_PROVISION_BEFORE_ADDING_IT_AGAIN: 'Is Already Provisioned For This Site Please Remove or Edit the Existing Provision Before Adding It Again',
  THIS_WILL_DELETE_THE_PROVISIONS_PERMANENTLY: 'This Will Delete the Provisions Permanently',
  THIS_WILL_DELETE_THE_PROVISION_PERMANENTLY: 'This Will Delete the Provision Permanently',
  PROVISION_UPDATED_SUCCESSFULLY: 'Provision Updated Successfully',
  SOMETHING_WENT_WRONG_WHILE_UPDATING_THE_PROVISION: 'Something Went Wrong While Updating the Provision',
  SELECT_A_SITE_FIRST: 'Select a Site First',
  ADDRESS_SAVED_SUCCESSFULLY: 'Address Saved Successfully',
  DELETE_ADDRESS: 'Delete Address',
  ADDRESS_DELETED_SUCCESSFULLY: 'Address Deleted Successfully',
  STREET_1: 'Street 1',
  EDITING_LOCATION: 'Editing Location',
  LOCATION_OPTIONS: 'Location Options',
  SITE_NUMBER_ALREADY_EXISTS: 'Site Number Already Exists',
  SITE_UPDATED_SUCCESSFULLY_1: 'Site Updated Successfully',
  SITE_CREATED_SUCCESSFULLY: 'Site Created Successfully',
  THIS_WILL_DELETE_THE_SITES_PERMANENTLY: 'This Will Delete the Sites Permanently',
  SITES_DELETED_SUCCESSFULLY: 'Sites Deleted Successfully',
  EDIT_SITE: 'Edit Site',
  ADD_SITE: 'Add Site',
  SITE_DETAILS: 'Site Details',
  PRIMARY_CONTACT_FOR_THIS_SITE: 'Primary Contact For This Site',
  CONFIGURE_FULFILLMENT_AND_FINANCE_SETTINGS_FOR_THE_SITE: 'Configure Fulfillment and Finance Settings For the Site',
  SENT_WHEN_A_PUBLIC_DOCUMENT_IS_ADDED_FOR_YOUR_SITES: 'Sent When a Public Document Is Added For Your Sites',
  SHOWING_ADDRESS_FOR: 'Showing Address For',
  EMAIL_ADDRESS_TOO_LONG: 'Email Address Too Long',
  PLEASE_SELECT_A_SITE_FIRST: 'Please Select a Site First',
  SITE_1: 'Site',
  LOADING_LOCATIONS: 'Loading Locations',
  ACCESS_THE_AMF_METHOD_PREMIUM_PORTAL_FOR_TRAINING_RESOURCES_AND_CONTENT_TAILORED_TO_YOUR_SITE: 'Access the AMF Method Premium Portal For Training Resources and Content Tailored to Your Site'
}

export const SHIPPING = {
  EX_WORKS: 'EX Works',
  DELIVERY_AT_PLACE: 'Delivery at Place',
  DELIVERY_DUTY_PAID: 'Delivery Duty Paid',
  UPS_NEXT_DAY_AIR_AM_DELIVERY: 'UPS Next Day Air AM Delivery',
  UPS_SECOND_DAY_AIR: 'UPS Second Day Air',
  FEDEX_SECOND_DAY_AIR: 'FedEx Second Day Air',
  DEFAULT_SHIPPING: 'Default Shipping'
}

export const CHAT_SUPPORT = {
  CHAT_WITH_US: 'Chat With Us',
  ASK_ME_ANYTHING_RELATED_TO_THE_PRODUCT: 'Ask Me Anything Related to Product',
  ANALYZING: 'Analyzing',
  ASK_ME_ANYTHING_1: 'Ask Me Anything',
  HOW_CAN_I_HELP_YOU_TODAY: 'How can I help you today?'
};
export const PATH_HELPERS = {
  resetPassword: (token = '') =>
    token ? `/reset-password/${token}` : '/reset-password',
};

export const FILE_UPLOAD = {
  EMPTY_FILE_1: 'Empty File',
  THE_UPLOADED_FILE_HAS_NO_VALID_DATA: 'The Uploaded File Has No Valid Data',
  THE_UPLOADED_FILE_HAS_NO_USABLE_PART_NUMBERS: 'The Uploaded File Has No Usable Part Numbers',
  CHOOSE_FILE: 'Choose File',
  UPLOAD_A_CSV_OR_EXCEL_FILE_CONTAINING_PART_DETAILS: 'Upload a Csv or Excel File Containing Part Details',
  NO_VALID_PARTS_FOUND_IN_THE_UPLOADED_FILE: 'No Valid Parts Found in Uploaded File',
  UPLOAD_PARTS: 'Upload Parts',
  ERROR_PROCESSING_UPLOADED_FILE_PLEASE_TRY_AGAIN: 'Error Processing Uploaded File Please Try Again',
  UPLOAD_A_PNG_JPG_OR_SVG_LOGO_MAXIMUM_SIZE_5_MB: 'Upload a Png/Jpg or Svg Logo Maximum Size 5 Mb',
  RENAME_FILE: 'Rename File',
  FILES_ALLOWED: 'Files Allowed',
  UNSUPPORTED_FILE_TYPES: 'Unsupported File Types',
  PLEASE_UPLOAD_IMAGE_PDF_WORD_EXCEL_OR_CSV_FILES: 'Please Upload Image/Pdf/Word/Excel or Csv Files',
  UNSUPPORTED_FILE_TYPE_PLEASE_UPLOAD_IMAGE_PDF_WORD_EXCEL_OR_CSV_FILES: 'Unsupported File Type Please Upload Image/Pdf/Word/Excel or Csv Files',
  CLICK_TO_ADD_MORE_FILES_OR_DRAG_AND_DROP_HERE: 'Click to Add More Files or Drag and Drop Here',
  DRAG_AND_DROP_FILES_HERE_OR_CLICK_TO_SELECT: 'Drag and Drop Files Here or Click to Select',
  ATTACHED_FILES: 'Attached Files',
  ERROR_LOADING_MARKDOWN_FILE: 'Error Loading Markdown File',
  UPLOAD_CSV: 'Upload Csv',
  FILE_NOT_AVAILABLE_TO_DOWNLOAD_PLEASE_CONTACT_CCR: 'File Not Available to Download Please Contact Ccr',
  UPLOAD_A_PNG_IMAGE_FOR_MACHINE_CARDS_AND_LISTINGS: 'Upload a Png Image For Machine Cards and Listings',
  UNSUPPORTED_FILE_TYPE_PLEASE_UPLOAD_STP_OR_STEP_FILES: 'Unsupported File Type Please Upload Stp or Step Files',
  ONLY_ONE_FILE_IS_ALLOWED_FOR_THIS_TYPE: 'Only One File Is Allowed For This Type',
  NO_FILES_UPLOADED_FOR_THIS_MACHINE_YET: 'No Files Uploaded For This Machine Yet',
  FILENAME_AZ: 'Filename A-Z',
  FILENAME_ZA: 'Filename Z-A',
  PROFILE_UPDATED_SUCCESSFULLY_1: 'Profile Updated Successfully',
  FAILED_TO_UPDATE_PROFILE: 'Failed to Update Profile',
  INVALID_FILE: 'Invalid File',
  FAILED_TO_PARSE_CSV_FILE: 'Failed to parse CSV file',
  FAILED_TO_PARSE_XLSX_FILE: 'Failed to parse XLSX file',
  ONLY_CSV_OR_XLSX_FILES_ARE_ALLOWED: 'Only CSV or XLSX files are allowed',
  FAILED_TO_OPEN_MODEL: 'Failed to open model'
};

export const UI_TEXT = {
    CLEAR_READ: 'Borrar leído',
  BACKDROP_UPLOAD_HELPER: 'Upload a JPG or PNG up to 5 MB for background use.',
  AUTH_BACKDROP_USAGE: 'Auth/Access pages using the Auth backdrop',
  CHOOSE_LOGO_TYPE: 'Choose Logo Type',
  CHOOSE_LOGO_USAGE: 'Apply this image as Primary, Sublogo or Favicon.',
  STOCK_IMAGE_MODAL_SUBTITLE: 'Choose an image to use as the default stock fallback.',
  NO_STOCK_IMAGES: 'No stock images available.',
  FONT_WEIGHT_DEFAULT: 'Default',
  FONT_WEIGHT_LIGHT: 'Light (300)',
  FONT_WEIGHT_REGULAR: 'Regular (400)',
  FONT_WEIGHT_MEDIUM: 'Medium (500)',
  FONT_WEIGHT_SEMIBOLD: 'Semi Bold (600)',
  FONT_WEIGHT_BOLD: 'Bold (700)',
  LANG_FRENCH: 'French',
  LANG_SPANISH: 'Spanish',
  LANG_GERMAN: 'German',
  THEME: 'Theme',
  COOKIE_SETTINGS: 'Cookie Settings',
  PLATFORM_SETTINGS: 'Platform Settings',
  ORDER_HISTORY_PRICE_VISIBILITY: 'Order History Price Visibility',
  CHECKOUT_SETTINGS: 'Checkout Settings',
  ORDER_TRACKER_SETTINGS: 'Order Tracker Settings',
  ORDER_STATUS_LABELS_HELPER: 'Example: Pending, Open Order, Shipped, Delivered, Invoiced, Canceled',
  ORDER_STATUS_MAPPING: 'Backend to frontend status mapping',
  NO_DATA_FOUND: 'No data found',
  ORDER_SETTINGS_DESC: 'Configure default currency, minimum order values, payment modes, and shipping/tax defaults used during checkout.',
  PRODUCT_DETAILS_DESCRIPTION: 'Provide the core product identifiers and basic listing info.',
  PRODUCT_IMAGE_TITLE: 'Product Image',
  PRODUCT_IMAGE_DESCRIPTION: 'Upload a PNG image for product cards and listings.',
  ATTACH_PRODUCT_IMAGE_PNG: 'Attach a product image (PNG).',
  ROLE_NAME: 'Role Name',
  RECEIVE_NOTIFICATIONS_ORDER_CREATIONS_REQUEST_LIST: 'Receive Notifications for Order Creations and Request List',
  LOADING_USER_FORM:'Loading user form...',
  ASSIGNING_SPECIFIC_LOCATIONS: 'You are now assigning specific Customer Locations to the Admin User.',
  CANCEL_ALLOCATIONS_TO_ALLOCATE_ALL: 'If you wish to allocate all, click <strong>Cancel Allocations.</strong>',
  ADMIN_ACCESS_ALL_LOCATIONS: 'Admin users will have access to all the Customer Locations.',
  ALLOCATE_SPECIFIC_LOCATIONS_BUTTON: 'If you still wish to allocate specific Customer Locations, press the button on the right labeled <strong>"Allocate Specific Locations."</strong>',
  CANCEL_ALLOCATIONS: 'Cancel Allocations',
  ALLOCATE_SPECIFIC_LOCATIONS: 'Allocate specific locations',
  DUPLICATE: 'Duplicate',
  DUPLICATE_USER_TITLE: 'Duplicate User',
  CREATE_COPY_OF: 'Create a copy of',
  THIS_WILL_ADD_A_GROUPED_ENTRY_BUT_WILL_EXPAND_INTO_REAL_LINE_ITEMS_ON_CHECKOUT: 'This will add a grouped entry but will expand into real line items on checkout.',
	THERE_ARE_NO_RSPL_PARTS_FOR_TYPE: 'There are no RSPL parts for {{type}}.',
	ANY_ITEMS_ADDED_IN_THE_MODEL_CART_WILL_NOT_BE_ADDED_TO_THE_APPLICATION_CART: 'Any items added in the Model Cart will not be added to the Application Cart.',
	ARE_YOU_SURE_YOU_WANT_TO_CLOSE: 'Are you sure you want to close?',
  ORDERS_REVENUE_TITLE: 'Orders Count by Revenue',
  ORDERS_BY_STATUS: 'Orders by Status',
  TOP_PURCHASED_PARTS: 'Top Purchased Parts',
  TOP_CUSTOMER: 'Top Customers',
  TOP_SITES: 'Top Sites',
  ORDERS_PAYMENT_MODES: 'Orders by Payment Modes',
  ORDERS_REVENUE_BY_CUSTOMER: 'Orders & Revenue by Customer',
  TOP_REQUESTED_PARTS: 'Top Requested Parts',
  ORDERS_EARNINGS_PAYMENT: 'Orders Earnings By Payment Mode',
  CUSTOMER_ORDER_PATTERS: 'Customer-Specific Order Patterns',
  NO_SITES_AVAILABLE: 'No sites available',
  CHAT_WELCOME_PREFIX: 'Start your conversation with our',
  CHAT_WELCOME_HIGHLIGHT: 'Smart AI Assistant',
  SORT_OPTIONS:'Sort Options',
  NO_RESULT_FOUND:'No results found',
  NUMBER_SEQUENCES: 'Number Sequences',
  ORDER_SETTINGS:'Order Settings',
  DEFAULT_CURRENCY:'Default Currency',
  NO_UNREAD_NOTIFICATIONS: 'No unread notifications',
  PAYMENT_MODES:'Payment Modes',
  CREDIT_CARD_PAYMENTS:'Credit Card Payments',
  SHIPPING_TAXES:'Shipping & Taxes',
  INVENTORY:'Inventory',
  MULTI_FACTOR_AUTHENTICATION:'Multi Factor Authentication (MFA)',
  USER_SUCCESSFULLY_UPDATED:'User Successfully Updated.',
  EDIT_USER:'Edit User',
  FILTERS_LABEL: 'Filters:',
  ADDITIONAL_FILTERS:'Additional Filters',
  NO_ADDITIONAL_FILTERS:'No Additional Filters are currently added',
  CLEAR_ALL_FILTERS:'Clear All Filters',
  LOADING:'Loading',
  SEARCH_RESULTS:'Search Results',
  COMING_SOON:'Coming Soon',
  PASSWORD_RESET_INFO:'If an account with this email exists, a password reset link will be sent.',
  PAGES:'Pages',
  PARTS:'Parts',
  PART:'Part #:',
  MACHINES:'Machines',
  MACHINE:'Machine #:',
  CATEGORIES:'Categories',
  DOCUMENT_CATEGORIES:'Document Categories',
  LOGGING_OUT:'Logging Out...',
  PLEASE_SELECT_CUSTOMER:'Please select a customer',
  MACHINE_SELL_NOTIFY:'Machine Sell Notify Customer Care',
  CUSTOMER_CARE_FOLLOW_UP_SUPPORT:'Notifies the customer care team when a machine is sold to ensure timely follow-up and support.',
  JOB_INDEFINITELY_NOTIFY:'If End Date & Time is left empty, the job will run indefinitely until canceled',
  REPETITION_TYPE:'Repetition Type',
  API_DETAILS:'API Details',
  JOB_HISTORY:'Job History',
  TEST_API_RESPONSE:'Test API Response:',
  SCHEDULE_JOB:'Schedule a New Job',
  SCHEDULE_NEW_RECURRING:'You can schedule a new recurring job or can edit or view details from the list on the left',
  NO_JOBS_FOUND:'No Jobs Found',
  PROVISIONED_MACHINES:'Provisioned Machines:',
  ADD_NEW_PROVISION:'Add New Provision',
  MACHINE_DETAILS:'Machine Details',
  PROVISION_FOR:'Provision For',
  PROVISION_STATUS:'Provision Status:',
  CREATE_NEW_USER:'Create New User',
  YOUR_ORDER_HAS_BEEN:'Order Status',
  SHIPPING_ADDRESS:'Shipping Address',
  BILLING_ADDRESS:'Billing Address',
  ADDITIONAL_ORDER_DETAILS:'Additional Order Details',
  PO_NUMBER:'PO Number:',
  DELIVERY_TERMS:'Delivery Terms:',
  MODE_OF_DELIVERY:'Mode of Delivery:',
  FREIGHT_NUMBER:'Freight Number:',
  SHIP_COMPLETE:'Ship Complete:',
  PRODUCT_DETAILS:'Product Details',
  ORDER_NOTES:'Order Notes',
  AT_LEAST_ONE_UPPERCASE:'At least one uppercase letter',
  MINIMUM_EIGHT_CHARACTERS:'Minimum 8 characters',
  AT_LEAST_ONE_SPECIAL_CHARACTERS:'At least one special character',
  AT_LEAST_ONE_NUMBER:'At least one number',
  CONFIRM_PASSWORD_MATCHES:'Confirm Password Matches',
  PROFILE_UPDATED_SUCCESSFULLY:'Your profile has been updated successfully!',
  REQUEST_DETAILS:'Request Details',
  REQUESTED:'Requested #:',
  REQUESTED_DATE:'Requested Date:',
  STATUS_HISTORY:'Status:',
  USER_DETAILS:'User Details',
  REQUESTED_BY:'Requested By:',
  USER_EMAIL:'User Email:',
  USER_PHONE:'User Phone:',
  CUSTOMER_DETAILS:'Customer Details',
  CUSTOMER_SITE_NAME:'Bakery Location Name:',
  CUSTOMER_SITE_NUMBER:'Bakery Location Number:',
  SHIPPING_ADDRESS:'Shipping Address:',
  PAYMENT_DETAILS:'Payment Details',
  PART_DETAILS:'Part Details',
  ORDER_FREQUENCY:'Order Frequency',
  SHIPPING_NOT_SAME_ADDRESS:'Note: The Order will be shipped to the Same Shipping address mentioned in the Original Order',
  CHOOSE_OPTIONS_FOR_SCHEDULING_ORDER:'Please choose your preferred options to proceed with scheduling the order.',
  SET_ORDER_SCHEDULE:'Set Order on a Schedule',
  UNKNOWN_STEP :'Unknown step',

  RESET_LINK_PASSWORD:'Password reset link sent successfully',
  SEND_PASSWORD_RESET_LINK:'Send Password Reset Link',
  MANAGE_USERS:'Manage Users',
  ADMIN_CAN_EDIT_REMOVE_USERS:'Admin can add, edit, or remove users here.',
  MANAGE_SITES:'Manage Sites',
  ADMIN_CAN_EDIT_REMOVE_SITES: 'Admins can view and edit default values related to bakery locations.',
  MANAGE_DOCUMENTS:'Manage Documents',
  ADMIN_CAN_ADD_REMOVE_DOCUMENTS:'Admin can add, or remove documents here.',
  MANAGE_MACHINE_PROVISIONS:'Manage Machine Provisions',
  ADMIN_CAN_MANAGE_MACHINE_PROVISIONS:'Admin can manage the machine provisions to the site.',
  UPLOAD_BULK_PROVISIONS:'Upload Bulk Provisions',
  DOWNLOAD:'Download{" "}',
  PROVISION_TEMPLATE:'Provision Template',
  FOR_REFERENCE:'for reference',
  FILE_SUMMARY:'File Summary',
  MANAGE_REMINDERS:'Manage Reminders',
  ADMIN_CAN_MANAGE_ALL_PRODUCT_DETAILS:'Admin can manage reminder, frequency, and minimum purchase count for products here.',
  MANAGE_CRON_JOBS:'Manage Cron Jobs',
  ADMIN_CAN_MANAGE_CRON_SCHEDULE_NEW_JOBS:'Admins can manage all the cron jobs and schedule new jobs.',
  MANAGE_PRICE_MARKUP:'Manage price markup and discount tiers applied to orders.',
  MANAGE_PROMOTIONS:'Manage checkout promotion codes and eligibility.',
  NO_PRICE_MARKUP_DATA:'No price markup ranges are configured yet.',
  MANAGE_ALL_CUSTOMERS:'Manage All Customers',
  ADMINS_CAN_CREATE_EDIT_DELETE_RECORDS:'Admins can Create/Edit/Delete records from Customer Master.',
  MANAGE_ALL_SITES:'Manage All Sites',
  ADMIN_CAN_CREATE_EDIT_DELETE_RECORDS_SITES:'Admins can Create/Edit/Delete records from Sites Master.',
  MANAGE_ALL_MACHINES:'Manage All Machines',
  ADMIN_CAN_ALL_RECORDS_MASTERS:'Admins can Create/Edit/Delete records from Machines Master.',
  MANAGE_ALL_PRODUCTS:'Manage All Products',
  ADMIN_CAN_CREATE_EDIT_DELETE_RECORD_FROM_PRODUCT:'Admins can Create/Edit/Delete records from Products Master.',
  SETTINGS:'Settings',
  MANAGE_ALL_APPLICATION_DEFAULT_VALUES:'Manage the core application settings and defaults',
  COMPANY_INFORMATIONS:'Company Information',
  MANAGE_ALL_THE_COMPANY_INFORMATION:'Manage All the Company information',
  THEMES:'Additional Settings',
  MANAGE_THEME_APPLICATION:'Manage additional application settings',
  MANAGE_USER_ROLES:'Manage user roles',
  REASSIGN_ROLE_PROMPT:'This role is assigned to the following users. Select an alternate role to reassign them, then confirm delete.',
  NO_USERS_AVAILABLE:'No Users Available',
  NO_USERS_FOUND:'No users found.',
  LOADING_USERS:'Loading Users...',
  LOADING_ROLES:'Loading Roles...',
  NO_MACHINES_AVAILABLE:'No Machines Available ',
  APPLIED_FILTERS:'Applied Filters',
  YOU_ARE_ALREADY_LOGGED:'You are already logged in!',
  ESTIMATED_SHIPPING_DATE:'Estimated Shipping Date:',
  FREQUENCTLY_TOGETHER:'Frequently Bought Together',
  ORDER_SUMMARY:'Order Summary',
  NOTE_SHIPPING_TAXES_INVOICE:'Note: Shipping & Taxes will be added to the Invoice.',
  MINIMUM_ORDER_AMOUNT_SHOULD_BE:'Minimum Order Amount should be',
  YOUR_CURRENT_ORDER_TOTAL_IS:'Your Current Order Total is ',
  YOU_ARE_NOT_AUTHORIZED_ORDER:'You are not authorized to place an order.',
  PLEASE_CONTACT_THE_CUTOMER_CARE_FOR_FURTHER_DETAILS:'Please contact the customer care for further details',
  SHIPPING_BILLING_ADDRESS:'Shipping & Billing Address',
  ORDER_SUMMARY:'ORDER SUMMARY',
  ENTER_YOUR_EMAIL_FOR_PASSWORD_RESET:'Enter your email to receive a password reset link.',
  BACK_TO_LOGIN:'Back to Login',
  UPGRADRE_YOUR_MANUFACTURING_PROCESS:'Upgrade your manufacturing process with precision parts from {{company}}. Explore our vast selection via our user-friendly 3D model interface. Streamline your operations and order with ease. Elevate your efficiency today!',
  REVOLUTIONIZE_SERVICE_MANAGEMENT:'Revolutionize Your Service Management with {{company}}',
  FORGOT_PASSWORD:'Forgot Password?',
  VERIFYING:'Verifying...',
  CREATE_NEW_ACCOUNT:'Create New Account',
  ADD_NEW_DOCUMENT:'Add New Document',
  UNCATEGORIZED:'Uncategorized',
  NO_ATTACHMENTS:'No attachment',
  NO_CATEGORY_ASSIGNED:'No category assigned',
  CATEGORY_DOCS_HELP:'These documents are currently assigned only to this category.',
  DELETE_CATEGORY_WARNING:'You are about to delete the category \"{{category}}\". Documents assigned only to this category may need reassignment.',
  REASSIGN_CATEGORY_INSTRUCTIONS:'Reassign the listed documents to another category or choose a fallback category',
  DOCUMENTS_NEEDING_ATTENTION:'Documents needing attention',
  FALLBACK_TO_UNCATEGORIZED:'Move documents to the default \"Uncategorized\" category',
  NO_CATEGORY_DOCUMENTS:'No documents are assigned only to this category.',
  DEFAULT_CATEGORY_LOCKED:'The default category cannot be deleted.',
  CCR_PHONE:'CCR Phone:',
  CCR_EMAIL:'CCR Email:',
  CCR_NAME:'CCR Name:',
  CCR_INFORMATION:'CCR Information',
  FULL_ADDRESS:'Full Address:',
  ADDRESS_NAME:'Address Name:',
  ADDRESS_INFORMATION:'Address Information',
  CUSTOMER:'Customer #:',
  CUSTOMER_NAME:'Customer Name:',
  CUSTOMER_INFORMATION:'Customer Information',
  MACHINE_3D_MODEL:'Machine 3D Model:',
  TWOD_MODEL:'2D Model:',
  DOCUMENTATIONS:'Documentation:',
  ORDERS:'Orders: ',
  ORDER_RECEIVED:'Order Recevied! Thank You,',
  ORDERS:'Order #:',
  CONFIRMATION_EMAIL_SENT:'A confirmation email will be sent to your registered email.',
  SHOWING_ALL_ORDERS_TO_DATE:'Showing all orders to date.',
  NOTE:'Note:',
  CLICK_ORDER_NUMBER_TO_VIEW_DETAILS:'Click on the Order Number to view details and tracking information.',
  PAGE_NOT_FOUND_ERROR:'404 - Page Not Found',
  PAGE_NOT_FOUND_DESCRIPTION:'The page you are looking for doesn\'t exist or has been moved.',
  PART_TYPE_FILTERS:'Part Type Filters',
  MODEL_3D: '3d Model',
  MODEL_2D: '2D Model',
  VIEW_ALL_MODELS: 'View All Models',
  LOADING_SITE_INFO: 'Loading site information...',
  LOADING_PARTS: 'Loading Parts...',
  ADMIN_PANEL: 'Admin Panel',
  MANAGE_ADMIN_SETTINGS: 'Manage all Admin Settings',
  CASE_DETAILS_NOT_FOUND: 'Case details not found.',
  WORKORDER_DETAILS_NOT_FOUND: 'Work Order details not found.',
  MY_INFORMATION: 'My Information',
  MANAGE_THEME: 'Manage Theme',
  CHANGE_THEME_COLOR: 'Change the Theme colors.',
  CREATE_A_NEW_LIST: 'Create a New List',
  NO_ITEMS_TO_DISPLAY: 'No items to display',
  NO_LISTS_FOUND: 'No Lists Found',
  LOGIN_PROMPT_PREFIX: 'Already a user?',
  LOGIN_LINK_TEXT: 'Login',
  NO_MACHINE_FOUND:'No Machines Found',
  SELECT_CREATE_LIST:'Select or Create a Recommendation List',
  SELECT_AN_ITEM_FROM_THE_LIST:'Select an item from the list',
  SELECT_ACCENT_COLOR:'Select Accent Color',
  BLUE:'Blue',
  RED:'Red',
  ORANGE:'Orange',
  CYAN:'Cyan',
  QTY:'Qty:',
  VIEW_ORDERS:'View Orders',
  NO_ORDERS_FOR_THIS_PART:'No orders for this part yet.',
  PART_TYPE:'Part Type:',
  WHERE_USED:'Where Used:',
  PRODUCT_UNAVAILABLE: 'This Product cannot be purchased, Please contact Service Tech or Customer Care for additional details.',
  ADD_PRODUCT_TO_LIST:'Add Product to List',
  ENTER_UNIQUE_NAME:'Enter a unique name',
  CREATE_SUPPORT_TICKET:'Create Support Ticket',
  SUPPORT_TICKET:'Support Ticket',
  TRACK_MANAGE_CUSTOMER_ISSUES:'Track and manage customer issues efficiently.',
  TICKET_STATUS:'Ticket Status',
  SUPPORT_ANYTIME:'24 Hr Support:',
  TECH_SUPPORT:'Tech Support:',
  CONTACT:'Contact',
  INITIATE_A_NEW_TICKET_TO_TRACK_CUSTOMER:'Initiate a new ticket to track customer issues.',
  SUPPORT_TICKET_MESSAGE:'In order to streamline support requests and better serve you, we utilize a support ticket system. Every support request is assigned a unique ticket number which you can use to track the progress and responses online. For your reference we provide complete archives and history of all your support requests. A valid email address is required to submit a ticket.',
  NAVIGATE_HOMEPAGE:'Navigating to home page...',
  RESENDING_OTP:'Resending OTP...',
  OTP_SEND_EMAIL:'Enter the OTP sent to your email address to verify your account. If you haven\'t received an OTP.',
  RESEND_OTP:'Resend OTP',
  HOME:'Home',
  SENDING_EMAIL:'Sending Email',
  SENT:'Sent',
  NOTIFY_CUSTOMER_CARE:'Notify Customer Care',
  VIEW_ALL_ORDERS_FOR_THIS_PART :'View all orders for this part',
  DEFAULT_PRODUCT:'Default Product',
  PO_NUMBER_REQUIRED:'PO number is required for PO payment mode',
  MODE_OF_DELIVERY_REQUIRED:'Mode of delivery is required',
  SHIP_REQUIRED:'Ship complete is required',
  DELIVERY_TERMS_REQUIRED:'Delivery terms are required',
  NAME_REQUIRED: 'Name is required',
  STREET_REQUIRED: 'Street is required',
  CITY_REQUIRED: 'City is required',
  ZIPCODE_REQUIRED: 'ZIP code is required',
  COUNTRY_REQUIRED: 'Country is required',
  STATE_REQUIRED: 'State is required',
  DELIVERY_TERMS_REQUIRED: 'Delivery terms are required',
  SHIP_REQUIRED: 'Ship complete is required',
  MODE_OF_DELIVERY_REQUIRED: 'Mode of delivery is required',
  PO_NUMBER_REQUIRED_FOR_PO_PAYMENT_MODE: 'PO number is required for PO payment mode',
  START_DATE_AND_TIME_REQUIRED:'Start Date & Time is required.',
  REPETITION_TYPE_REQUIRED:'Repetition Type is required.',
  API_URL_REQUIRED:'API URL is required.',
  API_METHOD_REQUIRED:'API Method is required.',
  API_AUTHENTICATION_TYPE_REQUIRED:'API Authentication Type is required.',
  API_KEY_REQUIRED:'API Key is required for this authentication type.',
  BEARED_TOKEN_REQUIRED:'Bearer Token is required.',
  USERNAME_REQUIRED:'Username is required for Basic Auth.',
  PASSWORD_REQUIRED:'Password is required for Basic Auth.',
  COMPANY_ADDRESS:'4470 Cox Rd #275, Glen Allen, VA 23060',
  COMPANY_MESSAGE:'{{company}} - your trusted partner in delivering quality products and innovative solutions.',
  CONTACT_US:'Contact Us',
  QUICK_LINKS:'Quick Links',
  LEGAL:'Legal',
  LANGUAGE:'Language',
  ENGLISH: 'English',
  FRENCH: 'French',
  SPANISH: 'Spanish',
  GERMAN: 'German',
  DOCUMENT: 'Documents',
  EULA_INSTRUCTIONS: 'By clicking the button below, you agree to the following EULA:',
  PERSONAL_DATA_USED_FOR_ORDER: 'Your personal data will be used to process your order, support your experience throughout this website, and for other purposes described in our{" "}',
  SUPPORT_PHONE_PRIMARY: '+1 (804) 399-0051',
  CATEGORY_REQUIRED: 'Category is required',
  FILE_REQUIRED: 'File is required',
  SITE_REQUIRED: 'Site is required',
  ORDERED_COUNT_TEXT: "This part has been ordered <1>{{count}}</1> time(s).",
  MANAGE_MACHINE_MODEL: 'Manage Machine Models',
  ADMIN_UPLOAD_MODEL_PARTS: 'Admin can upload machine models or change parts for a machine.',
  DRAG_DROP_FILE: ' Drag and drop files here (only .asm or .stp)',
  UPLOAD_CHANGE_PART: 'Upload Change Part Models',
  UPLOAD_MODELS: 'Upload Models',
  EDIT_MODEL_FILES: 'Edit Model Files',
  CHANGE_PART_FILES: ' Change Part Files',
  NO_SUB_ASSEMBLY_MODEL: 'No Sub-assembly models found',
  LEVEL: 'Level:',
  PARENT: 'Parent:',
  NO_SPLIT_MODELS_FOUND: 'No Split Models found',
  SPLIT_FILE: 'Split File',
  NO_MACHINE_MODELS_FOUND: 'No Machine Models found',
  MACHINE_MODEL: 'Machine Model',
  CHOOSE_A_MODEL: 'Choose a Model',
  MULTIPLE_MODELS_MESSAGE: ' machine has <b>multiple models</b> available. Please select one to continue.',
  SALES_OVERVIEW:'Sales Overview',
  CATEGORY_DISTRIBUTION:'Category Distribution',
  SALES_FUNNEL:'Sales Funnel',
  PERFORMANCE_METRICS:'Performance Metrics',
  SALES_BY_REGION:'Sales by Region',
  SALES_VS_PROFIT:'Sales vs. Profit',
  SALES_BY_PRODUCT:'Sales by Product',
  REVENUE_STREAMS:'Revenue Streams',
  PRODUCT_HIERARCHY:'Product Hierarchy',
  TARGET_COMPLETION:'Target Completion',
  SEARCHING:'Searching...',
  LOADING_SEARCH_RESULTS:'Loading Search Results...',
  TOTAL_SALES:'Total Sales',
  TOTAL_CUSTOMERS:'Total Customers',
  REVENUE:'Revenue',
  TRACKING_DETAILS: 'Tracking Details',
  NO_TRACKING_DETAILS: 'No tracking details available.',
  TRACKING_NUMBER: 'Tracking #',
  VIEW_TRACKING: 'View tracking',
  TOOLTIP_SAVE_ADDRESS: 'Save Address',
  TOOLTIP_EDIT_ADDRESS: 'Edit Address',
  TOOLTIP_CLOSE: 'Close',
  TOOLTIP_HOME_RELOAD_DRAWING: 'Home (Reload Drawing)',
  TOOLTIP_PREVIOUS_PAGE: 'Previous Page',
  TOOLTIP_NEXT_PAGE: 'Next Page',
  TOOLTIP_ZOOM_IN: 'Zoom In',
  TOOLTIP_ZOOM_OUT: 'Zoom Out',
  TOOLTIP_RESET_ZOOM: 'Reset Zoom',
  TOOLTIP_HELP: 'Help',
  TOOLTIP_EDIT: 'Edit',
  TOOLTIP_DELETE: 'Delete',
  TOOLTIP_CLOSE_MODEL_VIEW: 'Close Model View',
  TOOLTIP_HOME_RESET_VIEW: 'Home (Reset View)',
  TOOLTIP_PAN_MODE: 'Pan Mode (drag to pan)',
  TOOLTIP_ROTATE_MODE: 'Rotate Mode (drag to rotate)',
  TOOLTIP_ZOOM_IN_SCROLL: 'Zoom In (Scroll)',
  TOOLTIP_ZOOM_OUT_SCROLL: 'Zoom Out (Scroll)',
  TOOLTIP_ZOOM_TO_SELECTED: 'Zoom to Selected',
  TOOLTIP_SHOW_PARENT_IN_VIEW: 'Show Parent in View',
  TOOLTIP_ISOLATE_SELECTED: 'Isolate Selected',
  TOOLTIP_MORE: 'More',
  TOOLTIP_EXPAND_SIDE_BAR: 'Expand Side Bar',
  TOOLTIP_VIEW_SERVICE_REPORT: 'View Service Report',
  TOOLTIP_VIEW_DOCUMENT: 'View Document',
  TOOLTIP_OPEN_URL: 'Open URL',
  TOOLTIP_DOWNLOAD_FILE: 'Download File',
  TOOLTIP_REMOVE_FROM_LIST: 'Remove from the List',
  TOOLTIP_SHOW_TABLE: 'Show Table',
  TOOLTIP_VIEW_ROLE_DETAILS: 'View Role Details and Permissions',
  TOOLTIP_EDIT_ROLE: 'Edit Role',
  TOOLTIP_DUPLICATE_ROLE: 'Duplicate Role',
  TOOLTIP_START_NEW_CHAT: 'Start New Chat',
  TOOLTIP_CLOSE_HELP: 'Close Help',
  TOOLTIP_OPEN_PART_DETAILS: 'Open part details',
  TOOLTIP_OPEN_3D_MODEL: 'Open 3D model',
  TOOLTIP_OPEN_2D_DRAWING: 'Open 2D drawing',
  TOOLTIP_CART: 'Cart',
  UNREAD_NOTIFICATION: 'Unread Notifications',
  MARK_ALL_READ: 'Mark all read',
  SEARCH_NOTIFICATIONS: 'Search Notifications...',
  MARK_AS_READ: 'Mark as Read',
  NO_NOTIFICATIONS_YET: 'No Notifications Yet',
  NO_ORDERS_FOR_SITE: 'No Orders Found for the Site',
  NOTIFICATIONS_1: 'Notifications',
  UNREAD_1: 'Unread',
  MARK_AS_UNREAD: 'Mark as Unread',
  NOTIFICATION_PREFERENCES_UPDATED: 'Notification Preferences Updated',
  NOTIFICATION_DETAILS: 'Notification Details',
  CHOOSE_HOW_YOU_WANT_TO_RECEIVE_NOTIFICATIONS_FOR_EACH_EVENT: 'Choose how you want to receive notifications for each event',
  ERROR_OCCURRED_WHILE_FETCHING_ORDER: 'An error occurred while fetching the order. Please try again.',
  FAILED_TO_ACCEPT_EULA: 'Failed to accept EULA',
  MANAGE_FOOTER_LINKS_EULA_VERSIONS_AND_DEFAULT_SUPPORT_POLICIES_FROM_A_SINGLE_PLACE: 'Manage footer links, EULA versions, and default support policies from a single place.',
  CHECKING_ADMIN_PERMISSIONS: 'Checking admin permissions...',
  NOT_AUTHENTICATED_FOR_ADMIN_ROUTE: 'Not authenticated for admin route',
  ADMIN_ACCESS_DENIED_FOR_ROLE: 'Admin access denied for role:',
  PAGE_TITLE: 'Page Title',
  SUBTITLE_1: 'subtitle',
  HELLO: 'Hello',
  SIMULATING_LARGE_CONTENT: 'Simulating large content...',
  SHIPPED_ORDERS: 'Shipped Orders',
  AOV: 'AOV',
  ORDER_BY_STATUS: 'Order by Status',
  ORDER_BY_PAYMENT_MODE: 'Order by Payment Mode',
  ORDER_ID: 'Order ID',
  PRODUCT_PRICE: 'Product Price',
  PO_FILE: 'PO File',
  USD: 'USD',
  ORDERS_1: 'Orders #',
  NO_BOM_PATH_AVAILABLE_1: 'No BOM path available.',
  CLEAR_BOM_SEARCH: 'Clear BOM search',
  FILTERS_ACTIVE: 'Filters active',
  NO_MATCHING_PARTS_ADJUST_FILTERS_OR_SEARCH: 'No matching parts. Adjust filters or search.',
  EXPAND_THE_MACHINE_TO_VIEW_BOM_PARTS: 'Expand the machine to view BOM parts.',
  VIEW_REQUEST_LIST: 'View Request List',
  NA_1: 'N/A',
  TOOLTIP_NAVIGATE_TO_SUPPORT: 'Navigate to Support',
  TOOLTIP_ISOLATE_SELECTION: 'Isolate selection',
  TOOLTIP_MAKE_SELECTION_TRANSPARENT: 'Make selection transparent',
  TOOLTIP_MAKE_SELECTION_SOLID: 'Make selection solid',
  TOOLTIP_HIDE_SELECTION: 'Hide selection',
  TOOLTIP_SHOW_SELECTION: 'Show selection',
  TOOLTIP_SELECT_ALL_OCCURRENCES: 'Select all occurrences of selected parts',
  TOOLTIP_SELECT_ONLY_CLICKED: 'Select only the clicked occurrence',
  TOOLTIP_START_APP_TOUR: 'Start App Tour',
	REMOVE_PART_FROM_CART: 'Remove part from cart?',
	EMPTY_FILE_1: 'Empty File',
	THE_UPLOADED_FILE_HAS_NO_VALID_DATA: 'The uploaded file has no valid data.',
	INVALID_DATA: 'Invalid Data',
	THE_UPLOADED_FILE_HAS_NO_USABLE_PART_NUMBERS: 'The uploaded file has no usable part numbers.',
	INVALID_HEADERS: 'Invalid Headers',
	MISSING_HEADERS: 'Missing headers:',
	ADD_PARTS_TO_CART: 'Add Parts to Cart',
	YOU_CAN_ADD_PARTS_TO_CART_USING_A_CSVEXCEL_FILE_WITH_PART_AND_QTY: 'You can add parts to cart using a CSV/Excel file with Part # and Qty.',
	CHOOSE_FILE: 'Choose File',
	UPLOAD_A_CSV_OR_EXCEL_FILE_CONTAINING_PART_DETAILS: 'Upload a CSV or Excel file containing part details.',
	PARTS_SUMMARY: 'Parts Summary',
	FOLLOWING_PARTS_WILL_BE_ADDED_TO_CART_OR_REQUEST_LIST: 'Following parts will be added to cart or request list',
	QUANTITIES_CAN_BE_MODIFIED_EITHER_IN_THE_FILE_YOU_SELECTED_OR_ONCE_ITEMS_ARE_ADDED_TO_THE_CART_OR_REQUEST_LIST: 'Quantities can be modified either in the file you selected or once items are added to the cart or request list.',
	PURCHASABLE_PARTS: 'Purchasable Parts',
	TOTAL_1: 'Total:',
	NON_PURCHASABLE_PARTS: 'Parts That Need To Be Added To The Customer Care Request List',
	NOT_AVAILABLE_PARTS: 'Not Available Parts',
	NO_VALID_PARTS_FOUND_IN_THE_UPLOADED_FILE: 'No valid parts found in the uploaded file.',
	UPLOAD_PARTS: 'Upload Parts',
	CATEGORY_NAME_IS_REQUIRED: 'Category name is required',
	UNCAUGHT_ERROR: 'Uncaught error:',
	COMPONENET_STACK_TRACE_ERROR: 'Componenet Stack trace error:',
	OOPS: 'Oops...',
	GO_BACK: 'Go Back',
	AN_UNEXPECTED_ERROR_HAS_OCCURRED_PLEASE_TRY_AGAIN: 'An unexpected error has occurred. Please try again.',
	SORRY_THERE_WAS_AN_ERROR_PROCESSING_YOUR_REQUEST: 'Sorry, there was an error processing your request.',
	CHAT_WITH_US: 'Chat with Us',
	HOW_CAN_I_HELP_YOU_TODAY: 'How can I help you today?',
	ASK_ME_ANYTHING_RELATED_TO_THE_PRODUCT: 'Ask me anything related to the product',
	ANALYZING: 'Analyzing...',
	ERROR_GENERATING_RESPONSE_PLEASE_TRY_AGAIN: 'Error generating response. Please try again.',
	ASK_ME_ANYTHING_1: 'Ask me anything...',
	EX_WORKS: 'EX Works',
	FAILED_TO_UPLOAD_PARTS: 'Failed to upload parts.',
	PURCHASABLE_PARTS_ADDED_TO_CART: 'Purchasable parts added to Cart!',
	NO_VALID_PARTS_AVAILABLE_TO_ADD_TO_CART_OR_REQUEST_LIST: 'No valid parts available to add to Cart or Request List.',
	PREPAID_AND_ADD: 'Prepaid and Add',
	COLLECT_ON_DELIVERY: 'Collect/Exworks',
	DELIVERY_AT_PLACE: 'Delivery at Place',
	DELIVERY_DUTY_PAID: 'Delivery Duty Paid',
	UPS_GROUND: 'UPS Ground',
	UPS_NEXT_DAY_AIR: 'UPS Next Day Air',
	UPS_NEXT_DAY_AIR_AM_DELIVERY: 'UPS Next Day Air AM Delivery',
	UPS_SECOND_DAY_AIR: 'UPS Second Day Air',
	FEDEX_GROUND: 'FedEx Ground',
	FEDEX_SECOND_DAY_AIR: 'FedEx Second Day Air',
	SPECIAL_INSTRUCTIONS: 'Special Instructions',
	CAD: 'CAD',
	GBP: 'GBP',
	EUR: 'EUR',
	SGD: 'SGD',
	INR: 'INR',
	DEFAULT_SHIPPING: 'Default Shipping',
	DEFAULT_BILLING: 'Default Billing',
	ADDRESS_SAVED: 'Address saved',
	FAILED_TO_SAVE_ADDRESS: 'Failed to save address',
	ERROR_PROCESSING_UPLOADED_FILE_PLEASE_TRY_AGAIN: 'Error processing uploaded file. Please try again.',
	TERMS_CONDITIONS: 'Terms & Conditions',
	NOT_ACCEPTED: 'Not accepted',
	MISSING_REQUIRED_FIELDS: 'Missing Required Fields',
	SOME_REQUIRED_FIELDS_ARE_MISSING_OR_INCOMPLETE: 'Some required fields are missing or incomplete:',
	REVIEW_AND_FIX: 'Review and Fix',
	ACCEPT_EULA_1: 'Accept EULA',
	PVM_DASHBOARD: 'PVM Dashboard',
	PM_DASHBOARD: 'PM Dashboard',
	SOS_DASHBOARD: 'SOS Dashboard',
	COMPANY_EMAIL: 'Company Email',
	COMPANY_WEBSITE: 'Company Website',
	PRIMARY_1: 'Primary',
	FOOTER_1: 'Footer',
	ICON: 'Icon',
	UPLOAD_A_PNG_JPG_OR_SVG_LOGO_MAXIMUM_SIZE_5_MB: 'Upload a PNG, JPG, or SVG logo (maximum size 5 MB).',
	PARTS_FOR: 'Parts for',
	ARE_NOT_AVAILABLE: 'are not available',
	I_WOULD_LIKE_TO_ORDER_A_PART_FOR_MY_MACHINE: 'I would like to order a part for my machine -',
	BUT_THE_PARTS_ARE_NOT_AVAILABLE_PLEASE_SEND_THE_PARTS_LIST_IF_POSSIBLE: 'but the parts are not available. Please send the parts list if possible.',
	PHONE_IS_REQUIRED: 'Phone is required',
	MACHINE_NUMBER_IS_REQUIRED: 'Machine Number is required',
	SUBJECT_IS_REQUIRED: 'Subject is required',
	MESSAGE_IS_REQUIRED: 'Message is required',
	SUBMITTED_1: 'Submitted!',
	YOUR_MESSAGE_HAS_BEEN_SENT_SUCCESSFULLY_THE_CCR_TEAM_WILL_REACH_OUT_TO_YOU_SOON: 'Your message has been sent successfully. The CCR team will reach out to you soon.',
	SUBMISSION_FAILED: 'Submission failed',
	SOMETHING_WENT_WRONG_WHILE_SENDING_YOUR_MESSAGE_PLEASE_TRY_AGAIN: 'Something went wrong while sending your message. Please try again.',
	PLEASE_FILL_OUT_THE_FORM_BELOW_AND_THE_CCR_TEAM_WILL_REACH_OUT_TO_YOU: 'Please fill out the form below and the CCR team will reach out to you',
	IF_THIS_IS_AN_EMERGENCY_PLEASE_CALL_THE_EMERGENCY_NUMBER: 'If this is an emergency, please CALL the Emergency number ',
	CASE_TITLE_IS_REQUIRED: 'Case title is required',
	DESCRIPTION_IS_REQUIRED: 'Description is required',
	CASE_TYPE_IS_REQUIRED: 'Case type is required',
	REQUESTER_NAME_IS_REQUIRED: 'Requester Name is required',
	REQUESTER_EMAIL_IS_REQUIRED: 'Requester Email is required',
	CASE_CREATED: 'Case Created',
	YOUR_CASE_HAS_BEEN_SUBMITTED_SUCCESSFULLY_OUR_TEAM_WILL_REVIEW_IT_SHORTLY: 'Your case has been submitted successfully. Our team will review it shortly.',
	SOMETHING_WENT_WRONG_WHILE_CREATING_THE_CASE_PLEASE_TRY_AGAIN: 'Something went wrong while creating the case. Please try again.',
	FILL_DETAILS_TO_NOTIFY_ADMINS: 'Fill details to notify admins',
	CASE_TITLE_1: 'Case Title',
	CASE_DESCRIPTION: 'Case Description',
	CASE_TYPE_1: 'Case Type',
  LIST_NAME_IS_REQUIRED: 'List name is required!',
	GENERAL_ENQUIRY: 'General Enquiry',
	REQUESTER_PHONE: 'Requester Phone',
	CANADA: 'Canada',
	USER_STATUS_ROLE: 'User Status & Role',
	APPROVED_DOMAINS: 'Approved Domains',
  CUSTOMER_LOCATION_ALLOCATION: 'Customer Location Allocation',
	PLEASE_FILL_IN_BELOW_DETAILS_TO_CREATE_NEW_USER: 'Please fill in below details to create new user',
	USER_MANAGEMENT: 'User Management',
	ORDER_PROCESSING_PLEASE_WAIT: 'Order Processing, please wait.',
	OPTIONS_SAVED_SUCCESSFULLY: 'Options saved successfully',
	OKAY: 'Okay',
	FAILED_TO_SAVE_OPTIONS: 'Failed to save options',
  FAILED_TO_REFRESH_RECOMMENDATIONS: 'Failed to refresh recommendations:',
	PLEASE_REASSIGN_DOCUMENTS_OR_CHOOSE_A_FALLBACK_OPTION: 'Please reassign documents or choose a fallback option.',
	ALL_DOCUMENTS_IN_THIS_CATEGORY_ARE_ALSO_ASSIGNED_ELSEWHERE_NO_REASSIGNMENT_IS_REQUIRED: 'All documents in this category are also assigned elsewhere. No reassignment is required.',
	UNTITLED: 'Untitled',
	ENTER_NAME: 'Enter name',
	RENAME_FILE: 'Rename file',
	DOC_ICON: 'doc icon',
	NO_DESCRIPTION_AVAILABLE_1: 'No Description available',
	NO_MACHINES_ASSIGNED_1: 'No Machine(s) assigned',
	DOCUMENTS_1: 'Documents #:',
	ELECTRONICS: 'Electronics',
	CLOTHING: 'Clothing',
	BEAUTY: 'Beauty',
	SPORTS: 'Sports',
	LAST_MONTH: 'Last Month',
	CURRENT_MONTH: 'Current Month',
	SALES_1: 'Sales: $',
	PROFIT_1: 'Profit: $',
	SALES_2: 'Sales ()',
	PROFIT_2: 'Profit ()',
	SERVICES: 'Services',
	SALES_PROFIT: 'Sales & Profit',
	VISITS: 'Visits',
	LEADS: 'Leads',
	INQUIRIES: 'Inquiries',
	NEGOTIATIONS: 'Negotiations',
	CONTRACTS: 'Contracts',
	NORTH: 'North',
	SOUTH: 'South',
	EAST: 'East',
	WEST: 'West',
	CENTRAL: 'Central',
	DIRECT_1: 'Direct',
	AFFILIATES: 'Affiliates',
	PHONES: 'Phones',
	LAPTOPS: 'Laptops',
	ACCESSORIES: 'Accessories',
	MEN_1: 'Men',
	WOMEN: 'Women',
	FURNITURE: 'Furniture',
	DECOR: 'Decor',
	KITCHEN: 'Kitchen',
	PROGRESS_1: 'Progress',
	VALIDATION_ERROR: 'Validation Error',
	PLEASE_FIX_THE_HIGHLIGHTED_FIELDS: 'Please fix the highlighted fields.',
	FIRST_NAME_IS_REQUIRED: 'First name is required',
	LAST_NAME_IS_REQUIRED: 'Last name is required',

};

export const SOCIAL_MEDIA = {
	SOCIALMEDIA: 'Social Media',
	FACEBOOK: 'FACEBOOK',
	LINKEDIN: 'LINKEDIN',
	TWITTER: 'TWITTER',
	YOUTUBE: 'YOUTUBE',
};

export const ITEMS_TEXT = {
  SINGLE_ACTIVE_POLICY: 'Only one version can be active at a time for this section.',
  EULA_MULTIPLE_ACTIVE: 'Multiple active EULAs are allowed. They will be displayed in a stepper when users accept them.',
  POLICY_CENTER_SUBTITLE: 'Manage footer links, legal policies, and EULA versions from a central location.',
  SELECT_PRODUCTS: 'Select Products',
  USERS: "USERS",
  ORDER_ANALYTICS: "ORDER_ANALYTICS",
  USER_ANALYTICS: "USER_ANALYTICS",
  SITES: "SITES",
  ROLES: "ROLES",
  DOCUMENTS: "DOCUMENTS",
  DOCUMENTATION: "DOCUMENTATION",
  MACHINE_PROVISION: "MACHINE_PROVISION",
  REMINDERS: "REMINDERS",
  UPLOAD_MODELS: "UPLOAD_MODELS",
  ALL_PRODUCTS: "ALL_PRODUCTS",
  ALL_CUSTOMERS: "ALL_CUSTOMERS",
  ALL_SITES: "ALL_SITES",
  ALL_MACHINES: "ALL_MACHINES",
  SCHEDULER: "SCHEDULER",
  SETTINGS: "SETTINGS",
  COMPANY_INFORMATION: "COMPANY_INFORMATION",
  THEME: "THEME",
  POLICY_CENTER: "Policy Center",
  PRICE_MARKUPS: "PRICE_MARKUPS",
  PROMOTIONS: "PROMOTIONS",
  VERSION_INFO: "VERSION_INFO",
  AMFMETHOD_SCHEDULER: "AMFMETHOD_SCHEDULER",
  PARTS: "PARTS",
};

export const SETTINGS_TABS = {
  INVENTORY_1: 'Inventory & MFA',
}
export const THEME_TEXT = {
  getToggleLabel: (mode, t) =>
    mode === 'light' ? t('THEME.TOGGLE_TO_DARK_MODE') : t('THEME.TOGGLE_TO_LIGHT_MODE'),
};

export const UI_TEXT_HELPERS = {
  getOrderCountText: (count) => (
    <Trans i18nKey="UI_TEXT.ORDERED_COUNT_TEXT" values={{ count }} components={[<b />]} />
  ),
};

export const TABLE_HEADERS = {
  UPDATED_BY: 'Updated By',
  ADD:'Add',
  RSPL_CODE: 'RSPL Code',
  DATA_AREA_ID: 'Data Area ID',
  SHIPPING: 'Shipping',
  TAXES: 'Taxes',
  PRODUCT_NAME: 'Product Name',
  PRODUCT_NUMBER: 'Product Number',
  COUNT: 'Count',
  ORDER_NUMBER: 'Order Number',
  PAYMENT_MODE: 'Payment Mode',
  PO: 'Po',
  USERS: 'Users',
  CURRENCY: 'Currency',
  TOTAL: 'Total',
  FROM: 'From',
  TO: 'To',
  MARKUP_PERCENT: 'Markup / Discount %',
  STATUS: 'Status',
  CREATED_DATE: 'Created Date',
  ORDER_AGAIN: 'Order Again',
  ID: 'ID',
  NAME: 'Name',
  AGE:'Age',
  CUSTOMER_NUMBER:'Customer Number',
  CUSTOMER_NAME:'Customer Name',
  CUSTOMER_ADDRESS:'Customer Address',
  ACTIONS:'Actions',
  MACHINE_NUMBER:'Machine Number',
  GLOBAL_PRODUCT_CODE:'Global Product Code',
  MACHINE_NAME:'Machine Name',
  MACHINE_STATUS:'Machine Status',
  MACHINE_MODEL_FILE:'# Machine Model File(s)',
  MACHINE_MODEL_LAST_UPDATE:'Machine Model(s) Last Update',
  SPLIT_LAST_UPDATE:'Split File(s) Last Update',
  BOM_LAST_UPDATE:'BOM File(s) Last Update',
  CHANGE_PART_MODEL_LAST_UPDATE:'Change Part Model Last Update',
  SITE_NUMBER:'Site Number',
  INVOICE_ACCOUNT:'Invoice Account',
  PARENT_CUSTOMER:'Parent Customer',
  SITE_ADDRESS:'Site Address',
  MORE:'More',
  QUANTITY:'Quantity',
  EMAIL:'Email',
    PHONE:'Phone',
  PRICE:'Price',
  SUBTOTAL:'Subtotal:',
  PARTS_QUANTITY:'Part(s)',
  SUBJECT:'Subject',
  PART_NAME:'Part Name',
  REQUEST:'Request #',
  REQUEST_PARTS:'Requested Parts',
  REQUESTED_BY:'Requested By',
  VIEW_DETAILS:'View Details',
  MESSAGE:'Message',
	MANAGE: "TABLE_HEADERS.MANAGE",
  ADMINISTRATOR:"TABLE_HEADERS.ADMINISTRATOR",
  SETTINGS:"TABLE_HEADERS.SETTINGS",
  DEFAULTS:"TABLE_HEADERS.DEFAULTS",
  // Admin page section headers
  ADMINISTRATION: "TABLE_HEADERS.ADMINISTRATION",
  OPERATIONS: "TABLE_HEADERS.OPERATIONS",
  SUPER_ADMIN: "TABLE_HEADERS.SUPER_ADMIN",
  CONFIGURATION: "TABLE_HEADERS.CONFIGURATION",
  PLATFORM_SETTINGS: "TABLE_HEADERS.PLATFORM_SETTINGS",
  EMAIL: 'Email',
  UPDATED_DATE: 'Updated Date',
  PART: 'Part',
  QTY: 'Qty',
  DOCUMENT_NAME: 'Document Name',
  DESCRIPTION: 'Description',
  ASSIGNED_MACHINE: 'Assigned Machine',
  SCHEDULER_NUMBER: 'Schedule Number',
  START_DATE: 'Start Date',
  END_DATE: 'End Date',
  NEXT_INVOCATION: 'Next Invocation',
  CREATED_BY: 'Created By',
  LAST_UPDATED: 'Last Updated',
  MACHINE: 'Machine',
  ADDED_BY: 'Added By',
  DOCUMENTS: 'Documents',
  CASE_NUMBER: 'Case Number',
  TITLE: 'Title',
  DESCRIPTIONS: 'Description',
  TYPE: 'Type',
  PRIORITY: 'Priority',
  RESOLUTION_DETAILS: 'Resolution Details',
  RESOLUTION_DATE: 'Resolution Date',
  RESOLUTION_NOTES: 'Resolution Notes',
  WO_NUMBER: 'WO Number',
  ASSIGNED_RESOURCE: 'Assigned Resource',
  MACHINE_ID: 'Machine ID',
  SERVICE_START: 'Service Start',
  SERVICE_END: 'Service End',
  CLOSED_DATE: 'Closed Date',
  CUSTOMER: 'Customer',
  LOCATION: 'Location',
  SCHEDULE: 'Schedule',


};

export const ORDER_STATUSES = {
  PENDING: "Pending",
  OPEN_ORDER: "Open Order",
  SHIPPED: "Shipped",
  DELIVERED: "Delivered",
  INVOICED: "Invoiced",
  CANCELED: "Canceled",
};


export const EULA_ADMIN = {
  FAILED_TO_ACCEPT_EULA: 'Failed to Accept EULA',
  MANAGE_FOOTER_LINKS_EULA_VERSIONS_AND_DEFAULT_SUPPORT_POLICIES_FROM_A_SINGLE_PLACE: 'Manage Footer Links, EULA Versions, and Default Support Policies from a Single Place',
  CHECKING_ADMIN_PERMISSIONS: 'Checking Admin Permissions',
  NOT_AUTHENTICATED_FOR_ADMIN_ROUTE: 'Not Authenticated for Admin Route',
  ADMIN_ACCESS_DENIED_FOR_ROLE: 'Admin Access Denied for Role',
  ACCEPT_EULA_1: 'Accept EULA',
  FILL_DETAILS_TO_NOTIFY_ADMINS: 'Fill Details to Notify Admins',
  EULA_ACCEPTED: 'EULA Accepted',
  YOU_DO_NOT_HAVE_PERMISSION_TO_ACCESS_THIS_SECTION: 'You Do Not Have Permission to Access This Section',
  SENT_TO_ADMINS_WHEN_A_NEW_USER_REGISTERS: 'Sent to Admins When a New User Registers',
  SENT_TO_ADMINS_WHEN_A_CUSTOMER_PLACES_AN_ORDER: 'Sent to Admins When a Customer Places an Order',
  SENT_TO_ADMINS_WHEN_A_USER_NOTIFIES_CUSTOMER_CARE: 'Sent to Admins When a User Notifies Customer Care',
  SENT_TO_ADMINS_WHEN_A_NEW_SUPPORT_CASE_IS_CREATED: 'Sent to Admins When a New Support Case is Created',
  SENT_TO_ADMINS_WHEN_A_CONTACT_CCR_FORM_IS_SUBMITTED: 'Sent to Admins When a Contact CCR Form is Submitted',
  SENT_TO_ADMINS_WHEN_A_MACHINE_SALE_IS_SUBMITTED: 'Sent to Admins When a Machine Sale is Submitted',
  ADMIN_NOTIFICATIONS: 'Admin Notifications',
  USER_NOT_AUTHENTICATED_REDIRECTING_TO_LOGIN: 'User Not Authenticated, Redirecting to Login',
  THIS_IS_YOUR_INTENDED_ROLE_ADMINS_MAY_ADJUST_DURING_APPROVAL: 'This is Your Intended Role, Admins May Adjust During Approval',
  I_ACKNOWLEDGE_THAT_ORDERS_MAY_REQUIRE_ADMIN_APPROVAL: 'I Acknowledge That Orders May Require Admin Approval',
  PERMISSION_DENIED: 'Permission Denied',
  YOU_DO_NOT_HAVE_PERMISSION_TO_PERFORM_THIS_ACTION: 'You Do Not Have Permission to Perform This Action',
  SITE_SELECTION_IS_LOCKED_WHILE_ON_ADMIN_PAGE: 'Site Selection is Locked While on Admin Page',
  USER_NEED_TO_ACCEPT_EULA: 'User Needs to Accept EULA'
};
export const CART = {
  REMOVE_PART_FROM_CART: "Remove Part From Cart",
  ADD_PARTS_TO_CART: "Add Parts to Cart",
  YOU_CAN_ADD_PARTS_TO_CART_USING_A_CSVEXCEL_FILE_WITH_PART_AND_QTY: "You Can Add Parts to Cart Using a Csv/Excel File With Part and Qty",
  FOLLOWING_PARTS_WILL_BE_ADDED_TO_CART_OR_REQUEST_LIST: "Following Parts Will Be Added to Cart or Request List",
  QUANTITIES_CAN_BE_MODIFIED_EITHER_IN_THE_FILE_YOU_SELECTED_OR_ONCE_ITEMS_ARE_ADDED_TO_THE_CART_OR_REQUEST_LIST: "Quantities Can Be Modified Either in the File You Selected or Once Items Are Added to the Cart or Request List",
  ERROR_ADDING_TO_CART: "Error Adding to Cart",
  WERE_ADDED_TO_YOUR_CART: "Were Added to Your Cart",
  CART_AND_REQUEST_LIST_ARE_EMPTY: "Cart and Request List Are Empty",
  ADDED_TO_CART_1: "Added to Cart",
  UNABLE_TO_PUSH_SELECTED_ITEMS_TO_CARTREQUEST_LIST: "Unable to Push Selected Items to Cart/Request List",
  COULD_NOT_ADD_PARTS_TO_CART: "Could Not Add Parts to Cart",
  ADD_PARTS_TO_CART_AND_REQUEST_LIST: "Add Parts to Cart and Request List",
  NO_JUST_ADD_TO_CART: "No Just Add to Cart",
  PARTS_ADDED_TO_CART_AND_REQUEST_LIST: "Parts Added to Cart and Request List",
  PURCHASABLE_PARTS_ADDED_TO_CART: "Purchasable Parts Added to Cart",
  PURCHASABLE_ADDED_TO_CART: "Purchasable (Added to Cart)",
  REQUEST_LIST_ITEMS: "Request List Items",
  NON_ORDERABLE_PARTS: "Non-Orderable Parts",
  NO_PURCHASABLE_OR_REQUESTABLE_PARTS: "No Purchasable or Requestable Parts",
  SOME_PARTS_CANNOT_BE_PURCHASED_DIRECTLY_DO_YOU_WANT_TO_ADD_THEM_TO_THE_REQUEST_LIST_AS_WELL: "Some parts cannot be purchased directly. Do you want to add them to the Request List as well?",
  YES_ADD_BOTH: "Yes, Add Both",
  YES_ADD_TO_REQUEST_LIST: "Yes, Add to Request List",
  CANCEL: "Cancel",
  NO_VALID_PRODUCTS_TO_ADD_TO_CART: "No valid products to add to cart.",
  NO_PARTS_FOUND: "No Parts Found",
  NO_PARTS_UNDER_CATEGORY: "No parts under {categoryLabel}.",
  NO_PURCHASABLE_PARTS: "No Purchasable Parts",
  ALL_CATEGORY_PARTS_ARE_NON_PURCHASABLE: "All {categoryLabel} parts are non-purchasable.",
  ADDED_X_CATEGORY_PARTS_SKIPPED_Y: "Added {count} {categoryLabel} part(s). Skipped {skipped}.",
  FAILED: "Failed",
  PARTS_ADDED_TO_REQUEST_LIST: "Parts added to Request List!",
  FAILED_TO_ADD_PARTS_TO_REQUEST_LIST: "Failed to add parts to Request List."
};

export const CASE_MANAGEMENT = {
  IF_THIS_IS_AN_EMERGENCY_PLEASE_CALL_THE_EMERGENCY_NUMBER_522299153501: 'If This Is an Emergency Please Call the Emergency Number 522299153501',
  CASE_CREATED: 'Case Created',
  YOUR_CASE_HAS_BEEN_SUBMITTED_SUCCESSFULLY_OUR_TEAM_WILL_REVIEW_IT_SHORTLY: 'Your Case Has Been Submitted Successfully Our Team Will Review It Shortly',
  SOMETHING_WENT_WRONG_WHILE_CREATING_THE_CASE_PLEASE_TRY_AGAIN: 'Something Went Wrong While Creating the Case Please Try Again',
  CASE_TITLE_1: 'Case Title',
  CASE_DESCRIPTION: 'Case Description',
  CASE_TYPE_1: 'Case Type',
  EMERGENCY_CONTACT: 'Emergency Contact',
  NO_EMERGENCY_CONTACTS_AVAILABLE: 'No Emergency Contacts Available',
  PLEASE_CONTACT_CCR_TO_CREATE_A_CASE: 'Please Contact Ccr to Create a Case',
  NEW_CASE_CREATED: 'New Case Created'
}

export const GEOGRAPHIC = {
  CANADA: 'Canada',
  SOUTH: 'South',
  WEST: 'West',
  CENTRAL: 'Central',
  NEWEST_FIRST: 'Newest First',
  SORT_NEWEST_FIRST: 'Sort: Newest First',
  OLDEST_FIRST: 'Oldest First',
  ALL_CAUGHT_UP: 'All Caught Up',
};

export const USER_MANAGEMENT = {
  USER_STATUS_ROLE: 'User Status Role',
  SEARCH_CUSTOMER_LOCATIONS: 'Search Customer Locations',
  CUSTOMER_NUMBER_ALREADY_EXISTS: 'Customer Number Already Exists',
  CUSTOMER_UPDATED_SUCCESSFULLY: 'Customer Updated Successfully',
  CUSTOMER_CREATED_SUCCESSFULLY: 'Customer Created Successfully',
  THIS_WILL_DELETE_THE_CUSTOMERS_PERMANENTLY: 'This Will Delete the Customers Permanently',
  CUSTOMERS_DELETED_SUCCESSFULLY: 'Customers Deleted Successfully',
  BASIC_DEATILS_FOR_THE_CUSTOMER_TO_BE_ADDED: 'Basic Deatils For the Customer to Be Added',
  THE_DEFAULT_ADDRESS_FOR_THE_CUSTOMER: 'The Default Address For the Customer',
  SELECT_CUSTOMERS_OR_SITES_TO_SHARE_THIS_DOCUMENT_WITH: 'Select Customers or Sites to Share This Document With',
  NO_ROLES_SELECTED: 'No Roles Selected',
  PLEASE_SELECT_AT_LEAST_ONE_ROLE_TO_DELETE: 'Please Select at Least One Role to Delete',
  YOU_ARE_NOT_AUTHORIZED_TO_DELETE_ONE_OR_MORE_OF_THE_SELECTED_ROLES: 'You Are Not Authorized to Delete One or More of the Selected Roles',
  SELECTED_ROLES_HAVE_BEEN_SUCCESSFULLY_DELETED: 'Selected Roles Have Been Successfully Deleted',
  DUPLICATE_ROLE_1: 'Duplicate Role',
  NEW_ROLE_NAME: 'New Role Name',
  ROLE_DUPLICATED: 'Role Duplicated',
  COULD_NOT_DUPLICATE_ROLE: 'Could Not Duplicate Role',
  ROLE_DELETED_AND_USERS_REASSIGNED: 'Role Deleted and Users Reassigned',
  COULD_NOT_DELETE_ROLE: 'Could Not Delete Role',
  ROLE_TYPE: 'Role Type',
  USERS_1: 'Users',
  CREATE_NEW_ROLE: 'Create New Role',
  USER_1: 'User',
  PROVIDE_THE_CUSTOMER_AND_CORE_SITE_IDENTIFIERS_ALONG_WITH_CCR_CONTACT_INFO: 'Provide the Customer and Core Site Identifiers Along With Ccr Contact Info',
  USER_DUPLICATED: 'User Duplicated',
  REFRESH_USERS: 'Refresh Users',
  ALL_USERS_WITH_COUNT: 'All Users ({{count}})',
  ALL_ADMINS_WITH_COUNT: 'All Admins ({{count}})',
  USERS_BY_SITES: 'Users By Sites',
  SELECT_CUSTOMER_OR_SITE_TO_VIEW_USERS: 'Please select a customer and/or site to view the matching users.',
  PLEASE_NOTE: 'Please Note:',
  VISIBILITY_NOTE_SUPER_ADMIN: 'You can see all users across all sites. Edit and delete actions still depend on your role permissions.',
  VISIBILITY_SITE_SCOPE_ALL_SITES: 'all sites',
  VISIBILITY_SITE_SCOPE_ASSIGNED_SITES: 'your assigned sites',
  VISIBILITY_USER_SCOPE_CREATED_BY_ME: 'only users created by you',
  VISIBILITY_USER_SCOPE_ALL_IN_SCOPE: 'all users in scope',
  VISIBILITY_NOTE_SCOPED: 'You are seeing {{userScopeText}} within {{siteScopeText}}. Edit and delete actions may still be more limited based on your role settings.',
  DUPLICATE_USER_PASSWORD_NOTE: 'Duplicate users are created with no password and a Pending status. There is no default password. Use the password reset action to send a create/reset password link so the duplicated user can set their own password.',
  USER_CREATED_SUCCESSFULLY: 'User Created Successfully',
  PLEASE_ENTER_THE_DETAILS_BELOW_TO_CREATE_A_USER: 'Please Enter the Details Below to Create a User',
  SENT_WHEN_A_NEW_CUSTOMER_LOCATION_IS_ASSIGNED_TO_YOU: 'Sent When a New Customer Location Is Assigned to You',
  USER_NOTIFICATIONS: 'User Notifications',
  USER_SITE_OR_MACHINE_INFORMATION_IS_UNAVAILABLE: 'User Site or Machine Information Is Unavailable',
  USER_NOT_FOUND_PLEASE_TRY_LOGGING_IN_AGAIN: 'User Not Found Please Try Logging in Again',
  PLEASE_CONTACT_THE_CCR_TO_UPDATE_THE_EMAIL_OR_ROLE: 'Please Contact the CCR to Update the Email or Role',
  ACCESS_DENIED_USER_ROLE: 'Access Denied User Role',
  CREATE_ROLE: 'Create Role',
  INITIATE_A_NEW_TICKET_TO_TRACK_AND_MANAGE_CUSTOMER_ISSUES_OR_SERVICE_REQUESTS_EFFICIENTLY: 'Initiate a New Ticket to Track and Manage Customer Issues or Service Requests Efficiently',
  USER_CHANGED_TOUR_STATE_RESET_NEW_USERID: 'User Changed Tour State Reset New Userid',
  ASSIGNED_NEW_CUSTOMER_LOCATION: 'Assigned New Customer Location',
  NEW_USER_REGISTERED: 'New User Registered'
};

export const MACHINE_MANAGEMENT = {
  NO_MACHINES_ASSIGNED_1: 'No Machines Assigned',
  LOADING_3D_MODEL: 'Loading 3D Model',
  PLEASE_DESCRIBE_YOUR_INQUIRY_ABOUT_THE_MACHINE: 'Please Describe Your Inquiry About the Machine',
  MACHINES_VISIBILITY: 'Machines Visibility',
  MACHINE_NUMBER_ALREADY_EXISTS: 'Machine Number Already Exists',
  MACHINE_UPDATED_SUCCESSFULLY: 'Machine Updated Successfully',
  MACHINE_CREATED_SUCCESSFULLY: 'Machine Created Successfully',
  THIS_WILL_DELETE_THE_MACHINES_PERMANENTLY: 'This Will Delete the Machines Permanently',
  MACHINES_DELETED_SUCCESSFULLY: 'Machines Deleted Successfully',
  EDIT_MACHINE: 'Edit Machine',
  ADD_MACHINE: 'Add Machine',
  PROVIDE_THE_CORE_MACHINE_INFO_USED_FOR_SEARCH_AND_DISPLAY: 'Provide the Core Machine Info Used For Search and Display',
  MACHINE_IMAGE: 'Machine Image',
  ATTACH_A_MACHINE_IMAGE_PNG: 'Attach a Machine Image Png',
  THIS_MACHINE_WITH_THE_SAME_MACHINE_SERIAL_ALREADY_EXISTS: 'This Machine With the Same Machine Serial Already Exists',
  MACHINE_ALREADY_PROVISIONED_FOR_THIS_SITE: 'Machine Already Provisioned For This Site',
  MACHINES_SUCCESSFULLY_PROVISIONEDBR: 'Machines Successfully Provisionedbr',
  MACHINES_ALREADY_EXIST_IN_THE_SYSTEMBR: 'Machines Already Exist in the Systembr',
  VIEW_2D_DRAWING: 'View 2D Drawing',
  LOADING_MODELS_1: 'Loading Models',
  LOADING_PRODUCTS_AND_MACHINE_DATA: 'Loading Products and Machine Data',
  RENDERING_MODEL_VIEW: 'Rendering Model View',
  MODEL_LOADED: 'Model Loaded',
  AVAILABLE_IN_3D: 'Available in 3D',
  NOT_AVAILABLE_IN_3D: 'Not available in this 3D view. Please see another split model view.',
  SEARCH_IN_PARTS_TREE: 'Search in parts tree',
  THIS_WILL_ADD_A_GROUPED_ENTRY_BUT_WILL_EXPAND_INTO_REAL_LINE_ITEMS_ON_CHECKOUT: 'This will add a grouped entry but will expand into real line items on checkout.',
  THERE_ARE_NO_RSPL_PARTS_FOR_TYPE: 'There are no RSPL parts for {{type}}.',
  ANY_ITEMS_ADDED_IN_THE_MODEL_CART_WILL_NOT_BE_ADDED_TO_THE_APPLICATION_CART: 'Any items added in the Model Cart will not be added to the Application Cart.',
  ARE_YOU_SURE_YOU_WANT_TO_CLOSE: 'Are you sure you want to close?',
  MODEL_TYPE: 'Model Type',
  MACHINE_HAS_MULTIPLE_MODELS_AVAILABLE_PLEASE_SELECT_ONE_TO_CONTINUE: 'Machine Has Multiple Models Available Please Select One to Continue',
  SEARCH_MODELS_1: 'Search Models',
  NO_MACHINES_FOUND_MATCHING: 'No Machines Found Matching',
  LOADING_2D_DRAWING: 'Loading 2D Drawing',
  DRAWINGS_READY: 'Drawings Ready',
  MACHINE_PRODUCT_NOT_AVAILABLE: 'Machine Product Not Available',
  THIS_PRODUCT_IS_NOT_AVAILABLE_ON_ANY_MACHINES_AT_THE_SELECTED_SITE: 'This Product Is Not Available on Any Machines at the Selected Site',
  SELECT_A_MACHINE: 'Select a Machine',
  MACHINE_SOLD_NOTIFICATION: 'Machine Sold Notification',
  SEARCH_IN_PARTS_TREE: 'Search in parts tree',
  THIS_WILL_ADD_A_GROUPED_ENTRY_BUT_WILL_EXPAND_INTO_REAL_LINE_ITEMS_ON_CHECKOUT: 'This will add a grouped entry but will expand into real line items on checkout.',
  THERE_ARE_NO_RSPL_PARTS_FOR_TYPE: 'There are no RSPL parts for {{type}}.',
  ANY_ITEMS_ADDED_IN_THE_MODEL_CART_WILL_NOT_BE_ADDED_TO_THE_APPLICATION_CART: 'Any items added in the Model Cart will not be added to the Application Cart.',
  ARE_YOU_SURE_YOU_WANT_TO_CLOSE: 'Are you sure you want to close?',
  MODEL_TYPE: 'Model Type',
  MACHINE_HAS_MULTIPLE_MODELS_AVAILABLE_PLEASE_SELECT_ONE_TO_CONTINUE: 'Machine Has Multiple Models Available Please Select One to Continue',
  SEARCH_MODELS_1: 'Search Models',
  NO_MACHINES_FOUND_MATCHING: 'No Machines Found Matching',
  LOADING_2D_DRAWING: 'Loading 2D Drawing',
  DRAWINGS_READY: 'Drawings Ready',
  MACHINE_PRODUCT_NOT_AVAILABLE: 'Machine Product Not Available',
  THIS_PRODUCT_IS_NOT_AVAILABLE_ON_ANY_MACHINES_AT_THE_SELECTED_SITE: 'This Product Is Not Available on Any Machines at the Selected Site',
  SELECT_A_MACHINE: 'Select a Machine',
  MACHINE_SOLD_NOTIFICATION: 'Machine Sold Notification'
};

export const PRODUCT_CATEGORIES = {
  ELECTRONICS: 'Electronics',
  CLOTHING: 'Clothing',
  BEAUTY: 'Beauty',
  SPORTS: 'Sports',
  PHONES: 'Phones',
  LAPTOPS: 'Laptops',
  FURNITURE: 'Furniture'
};

export const AUTHENTICATION = {
  REDIRECTING_TO_LOGIN: 'Redirecting to Login',
  LAST_LOGIN: 'Last Login',
  REDIRECTING_TO_LOGIN_IN: 'Redirecting to Login In',
  SESSION_EXPIRED: 'Session Expired',
  YOUR_SESSION_HAS_EXPIRED_PLEASE_LOG_IN_AGAIN_TO_CONTINUE: 'Your Session Has Expired Please Log in Again to Continue',
  GO_TO_LOGIN: 'Go to Login',
  LOGIN_TO_PORTAL: 'Login to Portal'
};


export const DASHBOARD = {
  PVM_DASHBOARD: 'PVM Dashboard',
  PM_DASHBOARD: 'PM Dashboard',
  SOS_DASHBOARD: 'SOS Dashboard',
  SALES_1: 'Sales',
  PROFIT_1: 'Profit',
  SALES_2: 'Sales',
  PROFIT_2: 'Profit',
  SALES_PROFIT: 'Sales Profit',
  TOTAL_REVENUE: 'Total Revenue',
  PREVENTIVE_DASHBOARD: 'Preventive Dashboard',
  PREDICTIVE_DASHBOARD: 'Predictive Dashboard',
  ORDERS: 'Orders',
  REVENUE: 'Revenue',
  ORDERS_1: '# Orders'
}
export const GENERAL = {
    PARTS_ADDED_TO_REQUEST_LIST: "Part(s) Added to Request List",
   RSPL_DETAILS_TITLE: 'RSPL Details',
   RSPL_DETAILS_DESCRIPTION: 'Used for RSPL tracking and downstream integrations.',
  INDEX: 'Index',
	INVALID_EMAIL_FORMAT: 'Invalid email format',
	COMPANY_NAME_IS_REQUIRED: 'Company name is required',
	REGION_IS_REQUIRED: 'Region is required',
	ROLE_IS_REQUIRED: 'Role is required',
	STATUS_IS_REQUIRED: 'Status is required',
	APPROVED_DOMAINS_ARE_REQUIRED: 'Approved domains are required',
	PASSWORD_REQUIREMENTS_NOT_MET: 'Password requirements not met',
	FAILED_TO_UPDATE_USER_NO_USER_FOUND: 'Failed to Update User: No user found.',
	FILES_ALLOWED: 'file(s) allowed',
	UNSUPPORTED_FILE_TYPES: 'Unsupported file type(s):',
	PLEASE_UPLOAD_IMAGE_PDF_WORD_EXCEL_OR_CSV_FILES: 'Please upload Image, PDF, Word, Excel, or CSV files.',
	UNSUPPORTED_FILE_TYPE_PLEASE_UPLOAD_IMAGE_PDF_WORD_EXCEL_OR_CSV_FILES: 'Unsupported file type. Please upload Image, PDF, Word, Excel, or CSV files.',
	CLICK_TO_ADD_MORE_FILES_OR_DRAG_AND_DROP_HERE: 'Click to add more files or drag and drop here',
	DRAG_AND_DROP_FILES_HERE_OR_CLICK_TO_SELECT: 'Drag and drop files here, or click to select',
	ATTACHED_FILES: 'Attached Files',
	B_C_ORDERS: '{b}: {c} Orders',
	ORDER_COUNT: 'Order Count',
	ERROR_LOADING_MARKDOWN_FILE: 'Error loading markdown file.',
	FACEBOOK: 'Facebook',
	LINKEDIN: 'LinkedIn',
	TWITTER: 'Twitter',
	YOUTUBE: 'YouTube',
	SEARCH_CUSTOMER_LOCATIONS: 'Search Customer Locations',
	LOADING_3D_MODEL: 'Loading 3D Model...',
	NETWORK_ERROR_PLEASE_CHECK_YOUR_CONNECTION_AND_TRY_AGAIN: 'Network error. Please check your connection and try again.',
	NETWORK_ERROR_COULD_NOT_CONNECT_TO_SERVER_PLEASE_ENSURE_THE_BACKEND_IS_RUNNING: 'Network error: Could not connect to the server. Please ensure the backend is running.',
	SITE_ID_NOT_FOUND: 'Site ID not found',
	REDIRECTING_TO_LOGIN: 'Redirecting to Login...',
	EMAIL_CANNOT_BE_EMPTY: 'Email cannot be empty',
	FULL_NAME_IS_REQUIRED: 'Full name is required',
	FULL_NAME_CANNOT_BE_EMPTY: 'Full name cannot be empty',
	PHONE_NUMBER_IS_REQUIRED: 'Phone number is required',
	PHONE_NUMBER_CANNOT_BE_EMPTY: 'Phone number cannot be empty',
	PHONE_NUMBER_IS_REQUIRED_DOT: 'Phone number is required.',
	PHONE_NUMBER_CANNOT_EXCEED_10_DIGITS: 'Phone number cannot exceed 10 digits.',
	EMAIL_IS_REQUIRED: 'Email is required',
	EMAIL_ADDRESS_TOO_LONG: 'Email address too long',
	EMAIL_CANNOT_CONTAIN_CONSECUTIVE_DOTS: 'Email cannot contain consecutive dots',
	EMAIL_CANNOT_START_OR_END_WITH_A_DOT: 'Email cannot start or end with a dot',
	COUNTRY_IS_REQUIRED: 'Country is required',
	MESSAGE_CANNOT_BE_EMPTY: 'Message cannot be empty',
	SUBJECT_CANNOT_BE_EMPTY: 'Subject cannot be empty',
	PLEASE_ENTER_A_VALID_EMAIL_ADDRESS: 'Please enter a valid email address',
	REQUEST_BODY_JSON: 'Request Body JSON',
	PLEASE_FIX_THE_FOLLOWING_ERRORS: 'Please fix the following errors:',
	PLEASE_DESCRIBE_YOUR_INQUIRY_ABOUT_THE_MACHINE: 'Please describe your inquiry about the machine...',
	REQUEST_BODY_NOT_REQUIRED: 'Request Body (Not Required)',
	CUSTOMER_NUMBER_IS_REQUIRED: 'Customer number is required',
	OK: 'OK',
	CUSTOMER_NAME_IS_REQUIRED: 'Customer name is required',
	PLEASE_FILL_THE_REQUIRED_FIELDS: 'Please fill the required fields.',
	CUSTOMER_NUMBER_ALREADY_EXISTS: 'Customer number already exists.',
	CUSTOMER_UPDATED_SUCCESSFULLY: 'Customer updated successfully.',
	CUSTOMER_CREATED_SUCCESSFULLY: 'Customer created successfully.',
	FAILED_TO_SAVE_CUSTOMER: 'Failed to save customer.',
	THIS_WILL_DELETE_THE_CUSTOMERS_PERMANENTLY: 'This will delete the customer(s) permanently.',
	CUSTOMERS_DELETED_SUCCESSFULLY: 'Customer(s) deleted successfully.',
	UPLOAD_CSV: 'Upload CSV',
	BASIC_DEATILS_FOR_THE_CUSTOMER_TO_BE_ADDED: 'Basic deatils for the customer to be added',
	THE_DEFAULT_ADDRESS_FOR_THE_CUSTOMER: 'The Default address for the customer',
	STREET_2: 'Street 2',
	STREET_3: 'Street 3',
	MACHINES_VISIBILITY: 'Machines & Visibility',
	SELECT_CUSTOMERS_OR_SITES_TO_SHARE_THIS_DOCUMENT_WITH: 'Select customers or sites to share this document with',
	FILE_NOT_AVAILABLE_TO_DOWNLOAD_PLEASE_CONTACT_CCR: 'File not available to download, please contact CCR.',
	MACHINE_NUMBER_AND_NAME_ARE_REQUIRED: 'Machine number and name are required.',
	MACHINE_NUMBER_ALREADY_EXISTS: 'Machine number already exists.',
	MACHINE_UPDATED_SUCCESSFULLY: 'Machine updated successfully.',
	MACHINE_CREATED_SUCCESSFULLY: 'Machine created successfully.',
	FAILED_TO_SAVE_MACHINE: 'Failed to save machine.',
	THIS_WILL_DELETE_THE_MACHINES_PERMANENTLY: 'This will delete the machine(s) permanently.',
	MACHINES_DELETED_SUCCESSFULLY: 'Machine(s) deleted successfully.',
	EDIT_MACHINE: 'Edit Machine',
	ADD_MACHINE: 'Add Machine',
	PROVIDE_THE_CORE_MACHINE_INFO_USED_FOR_SEARCH_AND_DISPLAY: 'Provide the core machine info used for search and display.',
	MACHINE_IMAGE: 'Machine Image',
	UPLOAD_A_PNG_IMAGE_FOR_MACHINE_CARDS_AND_LISTINGS: 'Upload a PNG image for machine cards and listings.',
	ATTACH_A_MACHINE_IMAGE_PNG: 'Attach a machine image (PNG).',
	NO_ROLES_SELECTED: 'No Roles Selected',
	PLEASE_SELECT_AT_LEAST_ONE_ROLE_TO_DELETE: 'Please select at least one role to delete.',
	YOU_ARE_NOT_AUTHORIZED_TO_DELETE_ONE_OR_MORE_OF_THE_SELECTED_ROLES: 'You are not authorized to delete one or more of the selected roles.',
	SELECTED_ROLES_HAVE_BEEN_SUCCESSFULLY_DELETED: 'Selected role(s) have been successfully deleted.',
	AN_ERROR_OCCURRED_WHILE_DELETING_THE_SELECTED_ROLES_PLEASE_TRY_AGAIN: 'An error occurred while deleting the selected roles. Please try again.',
	DUPLICATE_ROLE_1: 'Duplicate Role:',
	ROLE_DUPLICATED: 'Role duplicated',
	COULD_NOT_DUPLICATE_ROLE: 'Could not duplicate role',
	ERROR_DUPLICATING_ROLE: 'Error duplicating role',
	ROLE_DELETED_AND_USERS_REASSIGNED: 'Role deleted and users reassigned',
	COULD_NOT_DELETE_ROLE: 'Could not delete role',
	ERROR_PROCESSING_REQUEST: 'Error processing request',
	ROLE_TYPE: 'Role Type',
	USERS_1: 'Users #',
	CANNOT_DELETE_THIS_ROLE: 'Cannot delete this role',
	CREATE_NEW_ROLE: 'Create New Role',
	FAILED_TO_FETCH_CUSTOMERS: 'Failed to fetch customers.',
	FAILED_TO_FETCH_CUSTOMERS_1: 'Failed to fetch customers:',
	THIS_MACHINE_WITH_THE_SAME_MACHINE_SERIAL_ALREADY_EXISTS: 'This Machine # with the same Machine Serial # already exists.',
	MACHINE_ALREADY_PROVISIONED_FOR_THIS_SITE: 'Machine already provisioned for this site.',
	IS_ALREADY_PROVISIONED_FOR_THIS_SITE_PLEASE_REMOVE_OR_EDIT_THE_EXISTING_PROVISION_BEFORE_ADDING_IT_AGAIN: 'is already provisioned for this site. Please remove or edit the existing provision before adding it again.',
	MACHINES_SUCCESSFULLY_PROVISIONEDBR: 'machine(s) successfully provisioned:<br>',
	MACHINES_FAILED_TO_PROVISION_DUE_TO_ERRORSBR: 'machine(s) failed to provision due to errors:<br>',
	MACHINES_ALREADY_EXIST_IN_THE_SYSTEMBR: 'machine(s) already exist in the system:<br>',
	THIS_WILL_DELETE_THE_PROVISIONS_PERMANENTLY: 'This will delete the provision(s) permanently.',
	THIS_WILL_DELETE_THE_PROVISION_PERMANENTLY: 'This will delete the provision permanently.',
	MACHINE_SERIAL_IS_REQUIRED: 'Machine Serial # is required',
	PROVISION_UPDATED_SUCCESSFULLY: 'Provision updated successfully.',
	FAILED_TO_UPDATE_PROVISION: 'Failed to update provision.',
	SOMETHING_WENT_WRONG_WHILE_UPDATING_THE_PROVISION: 'Something went wrong while updating the provision.',
	SELECT_A_SITE_FIRST: 'Select a site first',
	ADDRESS_NAME_IS_REQUIRED: 'Address Name is required',
	ADDRESS_SAVED_SUCCESSFULLY: 'Address saved Successfully',
	FAILED_TO_SAVE_ADDRESS_PLEASE_TRY_AGAIN: 'Failed to save address. Please try again.',
	DELETE_ADDRESS: 'Delete address?',
	ADDRESS_DELETED_SUCCESSFULLY: 'Address Deleted Successfully',
	FAILED_TO_DELETE_ADDRESS: 'Failed to delete address',
	DISCOUNT_CODE_CANNOT_BE_EMPTY: 'Discount code cannot be empty.',
	STREET_1: 'Street 1',
	USER_1: 'User #',
	EDITING_LOCATION: 'Editing Location:',
	LOCATION_OPTIONS: 'Location Options',
	SITE_NUMBER_IS_REQUIRED: 'Site number is required',
	CUSTOMER_IS_REQUIRED: 'Customer is required',
	CURRENCY_CODE_IS_REQUIRED: 'Currency code is required',
	SITE_NUMBER_ALREADY_EXISTS: 'Site number already exists.',
	SITE_UPDATED_SUCCESSFULLY_1: 'Site updated successfully.',
	SITE_CREATED_SUCCESSFULLY: 'Site created successfully.',
	FAILED_TO_SAVE_SITE: 'Failed to save site.',
	THIS_WILL_DELETE_THE_SITES_PERMANENTLY: 'This will delete the site(s) permanently.',
	SITES_DELETED_SUCCESSFULLY: 'Site(s) deleted successfully.',
	EDIT_SITE: 'Edit Site',
	ADD_SITE: 'Add Site',
	SITE_DETAILS: 'Site Details',
	PROVIDE_THE_CUSTOMER_AND_CORE_SITE_IDENTIFIERS_ALONG_WITH_CCR_CONTACT_INFO: 'Provide the customer and core site identifiers along with CCR contact info.',
	PRIMARY_CONTACT_FOR_THIS_SITE: 'Primary contact for this site.',
	DEFAULT_ADDRESS_FOR_THIS_SITE: 'The default address for this site.',
	CONFIGURE_FULFILLMENT_AND_FINANCE_SETTINGS_FOR_THE_SITE: 'Configure fulfillment and finance settings for the site.',
	FAILED_TO_FETCH_DATA_FROM: 'Failed to fetch data from',
	YOU_CANNOT_DELETE_YOUR_OWN_ACCOUNT: 'You cannot delete your own account.',
	PASSWORD_WILL_BE_CLEARED_AND_STATUS_SET_TO_PENDING: '? Password will be cleared and status set to Pending.',
	USER_DUPLICATED: 'User duplicated',
	FAILED_TO_DUPLICATE_USER: 'Failed to duplicate user',
	EULA_ACCEPTED: 'EULA Accepted',
	LAST_LOGIN: 'Last Login',
	REFRESH_USERS: 'Refresh Users',
	FAILED_TO_OPEN_MODEL: 'Failed to open model',
	VIEW_2D_DRAWING: 'View 2D Drawing',
	UNSUPPORTED_FILE_TYPE_PLEASE_UPLOAD_STP_OR_STEP_FILES: 'Unsupported file type. Please upload .stp or .step files.',
	LOADING_MODELS_1: 'Loading models...',
	ONLY_ONE_FILE_IS_ALLOWED_FOR_THIS_TYPE: 'Only one file is allowed for this type.',
	NO_FILES_UPLOADED_FOR_THIS_MACHINE_YET: 'No files uploaded for this machine yet.',
	LOADING_PRODUCTS_AND_MACHINE_DATA: 'Loading Products and Machine Data...',
	RENDERING_MODEL_VIEW: 'Rendering Model View...',
	MODEL_LOADED: 'Model Loaded',
	NONORDERABLE_PART: 'Non-Orderable Part',
	ADD_ALL_TO_CART: 'Add All to Cart',
	AVAILABLE_IN_3D: 'Available In 3D',
	NOT_AVAILABLE_IN_3D: 'Not available in this 3D view. Please see another split model view.',
	SEARCH_IN_PARTS_TREE: 'Search in parts tree',
	THIS_WILL_ADD_A_GROUPED_ENTRY_BUT_WILL_EXPAND_INTO_REAL_LINE_ITEMS_ON_CHECKOUT: 'This will add a grouped entry but will expand into real line items on checkout.',
	THERE_ARE_NO_RSPL_PARTS_FOR_TYPE: 'There are no RSPL parts for {{type}}.',
	ANY_ITEMS_ADDED_IN_THE_MODEL_CART_WILL_NOT_BE_ADDED_TO_THE_APPLICATION_CART: 'Any items added in the Model Cart will not be added to the Application Cart.',
	ARE_YOU_SURE_YOU_WANT_TO_CLOSE: 'Are you sure you want to close?',
	BOM_LEVEL: 'Bom Level',
	FILENAME_AZ: 'Filename (A-Z)',
	FILENAME_ZA: 'Filename (Z-A)',
	MODEL_TYPE: 'Model Type',
	MACHINE_HAS_MULTIPLE_MODELS_AVAILABLE_PLEASE_SELECT_ONE_TO_CONTINUE: 'machine has multiple models available. Please select one to continue.',
	SEARCH_MODELS_1: 'Search Models',
	SUBASSEMBLIES_BOM: 'Sub-assemblies (BOM) (',
	FAILED_TO_FETCH_MACHINE_DATA: 'Failed to fetch machine data.',
	AN_ERROR_OCCURRED_WHILE_FETCHING_DATA: 'An error occurred while fetching data:',
	NO_MACHINES_FOUND_MATCHING: 'No machines found matching "',
	USER_CREATED_SUCCESSFULLY: 'User Created Successfully!',
	FAILED_TO_CREATE_USER_NO_PRODUCT_FOUND: 'Failed to Create User: No product found.',
	PLEASE_ENTER_THE_DETAILS_BELOW_TO_CREATE_A_USER: 'Please enter the details below to create a user',
	SEND_PASSWORD_CREATION_EMAIL: 'Send password creation email',
	YOU_DO_NOT_HAVE_PERMISSION_TO_ACCESS_THIS_SECTION: 'You do not have permission to access this section.',
	NEWEST_FIRST: 'Newest First',
	UNREAD_NOTIFICATION: 'unread notification',
	NO_UNREAD_NOTIFICATIONS: 'No unread notifications',
	NOTIFICATIONS_1: 'Notifications',
	SORT_NEWEST_FIRST: 'Sort: Newest First',
	UNREAD_1: 'Unread',
	MARK_AS_UNREAD: 'Mark as unread',
	MARK_AS_READ: 'Mark as read',
	NO_NOTIFICATIONS_YET: 'No notifications yet.',
	SENT_TO_ADMINS_WHEN_A_NEW_USER_REGISTERS: 'Sent to admins when a new user registers.',
	SENT_TO_ADMINS_WHEN_A_CUSTOMER_PLACES_AN_ORDER: 'Sent to admins when a customer places an order.',
	SENT_TO_ADMINS_WHEN_A_USER_NOTIFIES_CUSTOMER_CARE: 'Sent to admins when a user notifies Customer Care.',
	SENT_TO_ADMINS_WHEN_A_NEW_SUPPORT_CASE_IS_CREATED: 'Sent to admins when a new support case is created.',
	SENT_TO_ADMINS_WHEN_A_CONTACT_CCR_FORM_IS_SUBMITTED: 'Sent to admins when a Contact CCR form is submitted.',
	SENT_TO_ADMINS_WHEN_A_MACHINE_SALE_IS_SUBMITTED: 'Sent to admins when a machine sale is submitted.',
	SENT_WHEN_A_PASSWORD_RESET_IS_REQUESTED_FOR_YOUR_ACCOUNT: 'Sent when a password reset is requested for your account.',
	SENT_WHEN_YOUR_PASSWORD_IS_CHANGED: 'Sent when your password is changed.',
	SENT_WHEN_A_NEW_CUSTOMER_LOCATION_IS_ASSIGNED_TO_YOU: 'Sent when a new customer location is assigned to you.',
	SENT_WHEN_A_PUBLIC_DOCUMENT_IS_ADDED_FOR_YOUR_SITES: 'Sent when a public document is added for your sites.',
	SENT_WHEN_YOUR_ORDER_IS_PLACED_SUCCESSFULLY: 'Sent when your order is placed successfully.',
	REMINDER_TO_COMPLETE_A_PENDING_PARTS_ORDER: 'Reminder to complete a pending parts order.',
	NOTIFICATION_PREFERENCES_UPDATED: 'Notification preferences updated.',
	FAILED_TO_SAVE_PREFERENCES: 'Failed to save preferences.',
	NOTIFICATION_DETAILS: 'Notification details',
	CHOOSE_HOW_YOU_WANT_TO_RECEIVE_NOTIFICATIONS_FOR_EACH_EVENT: 'Choose how you want to receive notifications for each event.',
	ADMIN_NOTIFICATIONS: 'Admin Notifications',
	USER_NOTIFICATIONS: 'User Notifications',
	SEARCH_NOTIFICATIONS: 'Search notifications...',
	THANKYOU_FOR_PLACING_THE_ORDER: 'Thankyou for placing the order',
	ERROR_ADDING_TO_CART: 'Error adding to cart',
	ERROR_ADDING_TO_REQUEST_LIST: 'Error adding to request list',
	FAILED_TO_LOAD_PRODUCT_DETAILS: 'Failed to load product details',
	ORDER_FAILURE: 'Order Failure',
	FAILED_TO_PLACE_ORDER: 'Failed to Place Order!',
	PLEASE_TRY_TO_PLACE_THE_ORDER_AGAIN_OR_CONTACT_CCR_FOR_FURTHER_ASSISTANCE: 'Please try to place the order again or contact ccr for further assistance',
	RETRY_ORDER: 'Retry Order',
	ORDERSEXPORTALLTIMEXLSX: 'OrdersExport_all_time.xlsx',
	ORDER_NOT_FOUND: 'Order Not Found',
	DETAILS_FOR_THE_SELECTED_ORDER_ARE_NOT_FOUND: 'Details for the selected order are not found',
	ORDER_DETAILS_NA: 'Order Details N/A',
	ALL_PARTS_FROM_ORDER: 'All part(s) from order',
	WERE_ADDED_TO_YOUR_CART: 'were added to your cart.',
	SOME_PARTS_WERE_ADDED_UNAVAILABLE: 'Some parts were added. Unavailable:',
	UNABLE_TO_ADD_PARTS_ALL_PRODUCTS_FROM_THIS_ORDER_ARE_UNAVAILABLE: 'Unable to add parts: All products from this order are unavailable.',
	MARK_INACTIVE: 'Mark inactive',
	MARK_ACTIVE: 'Mark active',
	TBD: 'TBD',
	LOADING_2D_DRAWING: 'Loading 2D Drawing...',
	BUILDING_PARTS_TREE: 'Building Parts Tree...',
	DRAWINGS_READY: 'Drawings Ready',
	NO_ITEMS_TO_ORDER: 'No Items to Order',
	CART_AND_REQUEST_LIST_ARE_EMPTY: 'Cart and request list are empty.',
	NO_ORDERABLE_PARTS: 'No Orderable Parts',
	UNABLE_TO_TRANSLATE_SELECTED_ITEMS_INTO_PRODUCTS: 'Unable to translate selected items into products.',
	MISSING_INFORMATION: 'Missing Information',
	USER_SITE_OR_MACHINE_INFORMATION_IS_UNAVAILABLE: 'User, site, or machine information is unavailable.',
	ITEMS_SUBMITTED: 'Items Submitted',
	ADDED_TO_CART_1: 'Added to Cart:',
	ADDED_TO_REQUEST_LIST: 'Added to Request List:',
	ORDER_FAILED: 'Order Failed',
	UNABLE_TO_PUSH_SELECTED_ITEMS_TO_CARTREQUEST_LIST: 'Unable to push selected items to cart/request list.',
	PRODUCT_NOT_AVAILABLE: 'Product Not Available',
	MACHINE_PRODUCT_NOT_AVAILABLE: 'Machine Product Not Available',
	THIS_PRODUCT_IS_NOT_AVAILABLE_ON_ANY_MACHINES_AT_THE_SELECTED_SITE: 'This product is not available on any machines at the selected site.',
	SELECT_A_MACHINE: 'Select a Machine',
	GO_TO_PRODUCT: 'Go to Product',
	GO_BACK: 'Go Back',
	ALL_FIELDS_ARE_REQUIRED: 'All fields are required.',
	LIST_NAME_ALREADY_EXISTS: 'A recommendation list with this name already exists for this site.',
	LIST_NAME_IS_REQUIRED: 'List name is required!',
	AN_ERROR_OCCURRED: 'An error occurred',
	PASSWORD_UPDATED_SUCCESSFULLY: 'Password updated successfully',
	CURRENT_PASSWORD_IS_INCORRECT: 'Current password is incorrect',
	AN_UNEXPECTED_ERROR_OCCURRED_PLEASE_TRY_AGAIN: 'An unexpected error occurred. Please try again.',
	ACTIVE_VERSION_1: 'Active version',
	FAILED_TO_UPDATE_PRICE_MARKUP: 'Failed to update price markup',
	NO_PRICE_MARKUP_RANGES_FOUND_IN_THE_SYSTEM: 'No price markup ranges found in the system.',
	PRODUCT_ACTIONS: 'Product actions',
	PRODUCT_LINK_NOT_FOUND: 'Product Link not found.',
	ADD_ALL_1: 'Add all',
	NAME_ASC: 'Name Asc',
	NAME_DESC: 'Name Desc',
	NUMBER_ASC: 'Number Asc',
	NUMBER_DESC: 'Number Desc',
	PRICE_ASC: 'Price Asc',
	PRICE_DESC: 'Price Desc',
	NO_PARTS_FOUND_2: 'No Parts Found',
	NO_PARTS_UNDER: 'No parts under',
	NO_PURCHASABLE_PARTS: 'No Purchasable Parts',
	PARTS_ARE_NONPURCHASABLE: 'parts are nonpurchasable.',
	PARTS_SKIPPED: 'part(s). Skipped',
	COULD_NOT_ADD_PARTS_TO_CART: 'Could not add parts to cart.',
	FAILED_TO_FETCH_DATA_NO_PRODUCT_FOUND: 'Failed to fetch data: No product found.',
	FAILED_TO_FETCH_DATA_NO_SUCCESS_FLAG: 'Failed to fetch data: No success flag.',
	FAILED_TO_FETCH_DATA_NO_DATA_FOUND_FOR: 'Failed to fetch data: No data found for',
	CANCEL_EDITING: 'Cancel Editing',
	SHOWING_ADDRESS_FOR: 'Showing Address for',
	EMAIL_ADDRESS_TOO_LONG: 'Email address too long',
	EMAIL_CANNOT_CONTAIN_CONSECUTIVE_DOTS: 'Email cannot contain consecutive dots',
	EMAIL_CANNOT_START_OR_END_WITH_A_DOT: 'Email cannot start or end with a dot',
	USER_NOT_FOUND_PLEASE_TRY_LOGGING_IN_AGAIN: 'User not found. Please try logging in again.',
	PHONE_NUMBER_IS_REQUIRED_1: 'Phone number is required.',
	PHONE_NUMBER_CANNOT_EXCEED_10_DIGITS: 'Phone number cannot exceed 10 digits.',
	PROFILE_UPDATED_SUCCESSFULLY_1: 'Profile updated successfully',
	FAILED_TO_UPDATE_PROFILE: 'Failed to update profile',
	PLEASE_CONTACT_THE_CCR_TO_UPDATE_THE_EMAIL_OR_ROLE: 'Please contact the CCR to update the Email or Role',
	VERIFYING_ACCESS: 'Verifying access...',
	USER_NOT_AUTHENTICATED_REDIRECTING_TO_LOGIN: 'User not authenticated, redirecting to login',
	ACCESS_DENIED_USER_ROLE: 'Access denied: User role',
	THIS_WILL_DELETE_THIS_LIST_PERMANENTLY: 'This will delete this list permanently.',
	PLEASE_SELECT_AT_LEAST_ONE_PART: 'Please select at least one part.',
	PLEASE_SELECT_A_SITE_FIRST: 'Please select a site first.',
	ADD_TO_REQUEST_LIST_1: 'Add to Request List?',
	THESE_PARTS_CANNOT_BE_PURCHASED_DIRECTLY_DO_YOU_WANT_TO_ADD_THEM_TO_YOUR_REQUEST_LIST: 'These parts cannot be purchased directly. Do you want to add them to your Request List?',
	YES_ADD_TO_REQUEST_LIST: 'Yes, Add to Request List',
	PARTS_ADDED_TO_REQUEST_LIST: 'Parts added to Request List!',
	ADD_PARTS_TO_CART_AND_REQUEST_LIST: 'Add Parts to Cart and Request List?',
	SOME_PARTS_CANNOT_BE_PURCHASED_DIRECTLY_DO_YOU_WANT_TO_ADD_THEM_TO_THE_REQUEST_LIST_AS_WELL: 'Some parts cannot be purchased directly. Do you want to add them to the Request List as well?',
	YES_ADD_BOTH: 'Yes, Add Both',
	NO_JUST_ADD_TO_CART: 'No, Just Add to Cart',
	PARTS_ADDED_TO_CART_AND_REQUEST_LIST: 'Parts added to Cart and Request List!',
	PURCHASABLE_PARTS_ADDED_TO_CART: 'Purchasable parts added to Cart!',
	NO_VALID_PARTS_SELECTED: 'No valid parts selected.',
	FAILED_TO_ADD_SELECTED_PARTS: 'Failed to add selected parts.',
	CREATED_BY_1: 'Created By:',
	THIS_IS_YOUR_INTENDED_ROLE_ADMINS_MAY_ADJUST_DURING_APPROVAL: 'This is your intended role. Admins may adjust during approval.',
	I_CONFIRM_I_AM_AUTHORIZED_TO_PLACE_PURCHASE_REQUESTS: 'I confirm I am authorized to place purchase requests.',
	I_AGREE_TO_FOLLOW_COMPANY_PROCUREMENT_POLICIES: 'I agree to follow company procurement policies.',
	I_ACKNOWLEDGE_THAT_ORDERS_MAY_REQUIRE_ADMIN_APPROVAL: 'I acknowledge that orders may require admin approval.',
	PLEASE_SELECT_PRODUCTS_TO_REMOVE_FROM_REQUEST_LIST: 'Please select products to remove from Request List.',
	PARTS_REMOVED_FROM_REQUEST_LIST: 'Part(s) Removed from Request List',
	PERMISSION_DENIED: 'Permission Denied',
	YOU_DO_NOT_HAVE_PERMISSION_TO_PERFORM_THIS_ACTION: 'You do not have permission to perform this action.',
	REDIRECTING_TO_LOGIN_IN: 'Redirecting to login in',
	LINK_SENT: 'Link Sent',
	PASSWORD_RESET_LINK_SENT: 'Password reset link sent.',
	PLEASE_MEET_ALL_PASSWORD_REQUIREMENTS: 'Please meet all password requirements.',
	RESETSET_PASSWORD: 'Reset/Set Password',
	SEND_PASSWORD_RESET_LINK_TO_USER: 'Send password reset link to user',
	MINIMUM_EIGHT_CHARACTERS_1: 'Minimum eight characters',
	CONFIRM_PASSWORD_MATCHES_1: 'Confirm password matches',
	ENTER_DETAILS: 'Enter details...',
	CREATE_ROLE: 'Create Role',
	ROLE_NAME: 'Role Name',
	PERMISSIONS: 'Permissions',
	SET_ORDER_FREQUENCY_CONFIRM: 'Set Order Frequency & Confirm',
	PO_NUMBER_CANNOT_EXCEED_50_CHARACTERS: 'PO number cannot exceed 50 characters',
	PPT: 'PPT',
	SITE_1: 'Site #:',
	ORDERS_2: 'Orders:',
	TOTAL_REVENUE: 'Total Revenue:',
	REPORT_NOT_FOUND: 'Report Not Found',
	THE_REQUESTED_WORK_ORDER_REPORT_COULD_NOT_BE_FOUND: 'The requested work order report could not be found.',
	AN_ERROR_OCCURRED_WHILE_FETCHING_THE_REPORT_PLEASE_TRY_AGAIN_LATER: 'An error occurred while fetching the report. Please try again later.',
	SESSION_EXPIRED: 'Session Expired',
	YOUR_SESSION_HAS_EXPIRED_PLEASE_LOG_IN_AGAIN_TO_CONTINUE: 'Your session has expired. Please log in again to continue.',
	GO_TO_LOGIN: 'Go to Login',
	ALREADY_IN_REQUEST_LIST: 'already in Request List',
	UNABLE_TO_SAVE: 'Unable to save',
	FOR_LATER_1: 'for later',
	SITE_SELECTION_IS_LOCKED_WHILE_ON_ADMIN_PAGE: 'Site selection is locked while on Admin page.',
	LOADING_LOCATIONS: 'Loading locations...',
	NO_MATCHES_FOUND: 'No matches found',
	USER_NEED_TO_ACCEPT_EULA: 'User Need to Accept EULA:',
	ORDERED_QTY: 'Ordered Qty',
	UNKNOWN_ORDER: 'Unknown Order',
	EMERGENCY_CONTACT: 'Emergency Contact',
	NO_EMERGENCY_CONTACTS_AVAILABLE: 'No Emergency Contacts available',
	INITIATE_A_NEW_TICKET_TO_TRACK_AND_MANAGE_CUSTOMER_ISSUES_OR_SERVICE_REQUESTS_EFFICIENTLY: 'Initiate a new ticket to track and manage customer issues or service requests efficiently.',
	PLEASE_CONTACT_CCR_TO_CREATE_A_CASE: 'Please Contact CCR to create a Case',
	CANNOT_MARK_TOUR_AS_COMPLETED_NO_USER_LOGGED_IN: 'Cannot mark tour as completed: no user logged in',
	MARKING_PAGE_TOUR_AS_COMPLETED_FOR: 'Marking page tour as completed for:',
	PAGE_TOUR_MARKED_AS_COMPLETED_SUCCESSFULLY: 'Page tour marked as completed successfully',
	FAILED_TO_MARK_PAGE_TOUR_AS_COMPLETED: 'Failed to mark page tour as completed:',
	FAILED_TO_UPDATE_PAGE_TOUR_STATUS: 'Failed to update page tour status:',
	NO_TOUR_STEPS_AVAILABLE_FOR_THIS_ROUTE: 'No tour steps available for this route',
	CANNOT_RESET_TOUR_NO_USER_LOGGED_IN: 'Cannot reset tour: no user logged in',
	TOUR_RESET_FOR_ROUTE: 'Tour reset for route:',
	FAILED_TO_RESET_TOUR: 'Failed to reset tour:',
	USER_CHANGED_TOUR_STATE_RESET_NEW_USERID: 'User changed, tour state reset. New userId:',
	AUTOSTARTING_TOUR_FOR_PAGE: 'Auto-starting tour for page:',
	USETOUR_MUST_BE_USED_WITHIN_TOURPROVIDER: 'useTour must be used within TourProvider',
	SEARCH_BY_ORDER_PO: 'Search by Order # / PO #...',
	ORDER_DETAILS_1: 'Order Details:',
	AMFMETHOD_PREMIUM: 'AMFPremium',
	ACCESS_THE_AMFMETHOD_PREMIUM_PORTAL_FOR_TRAINING_RESOURCES_AND_CONTENT_TAILORED_TO_YOUR_SITE: 'Access the AMFPremium portal for training resources and content tailored to your site.',
	LOGIN_TO_PORTAL: 'Login to Portal',
	EMAIL_VERIFIED_SUCCESSFULLY: 'Email verified successfully',
	EMAIL_ALREADY_VERIFIED_SUCCESSFULLY: 'Email Already verified successfully',
	FAILED_TO_VERIFY_EMAIL: 'Failed to Verify Email',
	WELCOME_1: 'Welcome,',
	UNABLE_TO_FETCH_POLICY_DATA: 'Unable to fetch policy data',
	TOKEN_EXPIRED: 'Token expired',
	FAILED_TO_VERIFY_RESOURCE: 'Failed to verify resource:',
	ACCOUNT_APPROVED: 'Account approved',
	REGISTRATION_CONFIRMATION: 'Registration confirmation',
	FORGOT_PASSWORD_1: 'Forgot password',
	PASSWORD_CHANGED: 'Password changed',
	ASSIGNED_NEW_CUSTOMER_LOCATION: 'Assigned new customer location',
	CONTACT_CCR_FORM_SUBMITTED: 'Contact CCR form submitted',
	CONTACT_CCR_SUBMISSION: 'Contact CCR Submission',
	MACHINE_SOLD_NOTIFICATION: 'Machine sold notification',
	REQUEST_LIST_PARTS_PURCHASABLE: 'Request list parts purchasable',
	ORDER_PLACED_SUCCESSFULLY: 'Order placed successfully',
	PART_ORDER_REMINDER: 'Part order reminder',
	PREVENTIVE_DASHBOARD: 'Preventive Dashboard',
	PREDICTIVE_DASHBOARD: 'Predictive Dashboard',
	US_DOLLAR: 'US Dollar',
	CANADIAN_DOLLAR: 'Canadian Dollar',
	BRITISH_POUND: 'British Pound',
	SINGAPORE_DOLLAR: 'Singapore Dollar',
	INDIAN_RUPEE: 'Indian Rupee',
	PAGE_TITLE: 'Page Title',
	SUBTITLE_1: 'Subtitle',
	HELLO: 'Hello',
	SIMULATING_LARGE_CONTENT: 'Simulating Large Content',
	AOV: 'AOV',
	PRODUCT_PRICE: 'Product Price',
	USD: 'USD',
	FILTERS_ACTIVE: 'Filters Active',
	NO_MATCHING_PARTS_ADJUST_FILTERS_OR_SEARCH: 'No Matching Parts Adjust Filters or Search',
	VIEW_REQUEST_LIST: 'View Request List',
	NA_1: 'N/A',
	PARTS_SUMMARY: 'Parts Summary',
	PURCHASABLE_PARTS: 'Purchasable Parts',
	TOTAL_1: 'Total',
	NON_PURCHASABLE_PARTS: 'Parts That Need To Be Added To The Customer Care Request List',
	NOT_AVAILABLE_PARTS: 'Not Available Parts',
	HOW_CAN_I_HELP_YOU_TODAY: 'How Can I Help You Today',
	SPECIAL_INSTRUCTIONS: 'Special Instructions',
	DEFAULT_BILLING: 'Default Billing',
	REVIEW_AND_FIX: 'Review and Fix',
	PRIMARY_1: 'Primary',
	PARTS_FOR: 'Parts For',
	ARE_NOT_AVAILABLE: 'Are Not Available',
	BUT_THE_PARTS_ARE_NOT_AVAILABLE_PLEASE_SEND_THE_PARTS_LIST_IF_POSSIBLE: 'But the Parts are Not Available Please Send the Parts List if Possible',
	SUBMITTED_1: 'Submitted',
	YOUR_MESSAGE_HAS_BEEN_SENT_SUCCESSFULLY_THE_CCR_TEAM_WILL_REACH_OUT_TO_YOU_SOON: 'Your Message Has Been Sent Successfully the CCR Team Will Reach Out to You Soon',
	SOMETHING_WENT_WRONG_WHILE_SENDING_YOUR_MESSAGE_PLEASE_TRY_AGAIN: 'Something Went Wrong While Sending Your Message Please Try Again',
	PLEASE_FILL_OUT_THE_FORM_BELOW_AND_THE_CCR_TEAM_WILL_REACH_OUT_TO_YOU: 'Please Fill Out the Form Below and the CCR Team Will Reach Out to You',
	GENERAL_ENQUIRY: 'General Enquiry',
  ON_HOLD_STATUS: 'On Hold Status',
  PAYMENT_TERMS: 'Payment Terms',
  DISCOUNT_MARKUP_PERCENT: 'Discount/Markup (%)',
  ENTER_DISCOUNT_MARKUP_PERCENTAGE: 'Enter discount/markup percentage (+ve or -ve)',
	REQUESTER_PHONE: 'Requester Phone',
	APPROVED_DOMAINS: 'Approved Domains',
	OPTIONS_SAVED_SUCCESSFULLY: 'Options Saved Successfully',
	OKAY: 'Okay',
	EUR: 'EUR',
	GBP: 'GBP',
	INR: 'INR',
	PLEASE_REASSIGN_DOCUMENTS_OR_CHOOSE_A_FALLBACK_OPTION: 'Please Reassign Documents or Choose a Fallback Option',
	UNTITLED: 'Untitled',
	ENTER_NAME: 'Enter Name',
	NO_DESCRIPTION_AVAILABLE_1: 'No Description Available',
	DOCUMENTS_1: 'Documents',
	LAST_MONTH: 'Last Month',
	CURRENT_MONTH: 'Current Month',
	VISITS: 'Visits',
	LEADS: 'Leads',
	INQUIRIES: 'Inquiries',
	NEGOTIATIONS: 'Negotiations',
	CONTRACTS: 'Contracts',
	DIRECT_1: 'Direct',
	AFFILIATES: 'Affiliates',
	ACCESSORIES: 'Accessories',
	MEN_1: 'Men',
	WOMEN_1: 'Women',
	DECOR: 'Decor',
	KITCHEN: 'Kitchen',
	PROGRESS_1: 'Progress',
	MANAGER: 'Manager',
	LOADING_MAP: 'Loading Map',
	ERROR_LOADING_MAP_DATA: 'Error loading map data',
	GUIDES_DOCUMENTATION_AND_TROUBLESHOOTING: 'Guides Documentation and Troubleshooting',
	DONT_HAVE_AN_ACCOUNT: "Don't Have an Account",
	FULL_NAME_MUST_BE_AT_LEAST_2_CHARACTERS: 'Full Name Must be at Least 2 Characters',
	FULL_NAME_IS_TOO_LONG: 'Full Name is Too Long',
	FULL_NAME_MUST_CONTAIN_LETTERS: 'Full Name Must Contain Letters',
	PHONE_NUMBER_IS_TOO_SHORT: 'Phone Number is Too Short',
	PHONE_NUMBER_IS_TOO_LONG: 'Phone Number is Too Long',
	PHONE_NUMBER_CAN_ONLY_CONTAIN_DIGITS_SPACES_DASHES_PARENTHESES_AND: 'Phone Number Can Only Contain Digits Spaces Dashes Parentheses and',
	MESSAGE_MUST_BE_AT_LEAST_10_CHARACTERS: 'Message Must be at Least 10 Characters',
	MESSAGE_IS_TOO_LONG_MAX_1000_CHARACTERS: 'Message is Too Long Max 1000 Characters',
	SUBJECT_MUST_BE_AT_LEAST_3_CHARACTERS: 'Subject Must be at Least 3 Characters',
	REQUEST_BODY_JSON: 'Request Body JSON',
	YES_DELETE_IT: 'Yes Delete It',
	DOWNLOAD_TEMPLATE: 'Download Template',
	COUNTY: 'County',
	PO_BOX: 'PO Box',
	ENTER_A_VALID_HTTPS_URL: 'Enter a Valid HTTPS URL',
	SELL_PRICE: 'Sell Price',
	SELL_END_DATE: 'Sell End Date',
	CONFIRM_DELETION: 'Confirm Deletion',
	YES_DELETE_1: 'Yes Delete',
	DELETED_1: 'Deleted',
	REASSIGN_TO_1: 'Reassign To',
	FILTERS_1: 'Filters',
	PLEASE_FILL_IN_THE_HIGHLIGHTED_FIELDS: 'Please Fill in the Highlighted Fields',
	CCR_CONTACT_1: 'CCR Contact',
	AUSA: 'AUSA',
	ACAN: 'ACAN',
	EUUK: 'EUUK',
	CAD: 'CAD',
	SGD: 'SGD',
	CREATE_A_COPY_OF: 'Create a Copy of',
	CONFIRM_ACTION: 'Confirm Action',
	REVIEW_DETAILS_AND_CONTINUE: 'Review Details and Continue',
	SELECTION_TOOLS: 'Selection Tools',
	SELECTED_PARTS: 'Selected Parts',
	NO_NAME: 'No Name',
	SELECT_CURRENT: 'Select Current',
	SELECT_ALL_OCCURRENCES_1: 'Select All Occurrences',
	MULTIPLE_PARTS_SELECTED: 'Multiple Parts Selected',
	UNIQUE_PARTS_SELECTED: 'Unique Parts Selected',
	NO_PARTS_FOUND_1: 'No Parts Found',
	SUBASSEMBLY: 'Subassembly',
	PER_PAGE: 'Per Page',
	QUERY_RETURNED_NO_DATA: 'No results found for the selected filters',
	NOT_AUTHORIZED_1: 'Not Authorized',
	MINS_AGO: 'Mins Ago',
	YESTERDAY_AT: 'Yesterday At',
	HOURS_AGO: 'Hours Ago',
	ALL_CAUGHT_UP: 'All Caught Up',
	SORT_OLDEST_FIRST: 'Sort: Oldest First',
  SORT_NEWEST_FIRST: 'Sort: Newest First',
	READ_2: 'Read',
	MARK_ALL_READ: 'Mark All Read',
	SENT_WHEN_A_REQUEST_LIST_ITEM_BECOMES_PURCHASABLE: 'Sent When a Request List Item Becomes Purchasable',
	INAPP: 'In-App',
	SAVE_PREFERENCES_1: 'Save Preferences',
	SHOWING_1: 'Showing',
  DONT_HAVE_AN_ACCOUNT: "Don't Have an Account"

};

export const BUTTON = {
   RESTORE_DEFAULTS: 'Restore defaults',
   LOGIN:'Login',
   LOGGING_IN:'Logging in...',
   CLOSE :'Close',
   BUY_AGAIN:'Buy Again',
   EXPORT_ORDERS:'Export Orders',
   SET_PRIMARY_LOGO: 'Set as Primary Logo',
   SET_FOOTER_LOGO: 'Set as Footer / Sublogo',
   SET_ICON: 'Set as Browser Icon (Favicon)',
   ADD_STATUS_MAPPING: 'Add Status Mapping',
   SUBMIT:'Submit',
   SAVE_CHANGES:'Save Changes',
	 CANCEL: 'Cancel',
   SAVED:'Saved',
   SAVING:'Saving...',
   TEST_API:'Test API',
   SAVE_JOB:'Save Job',
   SUBMIT_PROVISION:'Submit Provision',
   CREATE_USER:'Create User',
   CREATING:'Creating...',
   UPDATE_PASSWORD:'Update Password',
   UPDATE_PROFILE:'Update Profile',
   BACK:'Back',
   NEXT:'Next',
   SET_SCHEDULE:'Set Schedule',
   UPLOAD_BULK:'Upload Bulk',
   UPDATE:'Update',
   CLEAR:'Clear',
   GO_TO_HOME:'Go to Home',
   LOGOUT:'Logout',
   CLEAR_CART:'Clear Cart',
   CREATE_ORDER_SCHEDULE:'Create Order Schedule',
   PLACING_ORDER:'Placing Order',
   VIEW_RECOMMENDATIONS:'View Recommendations',
   ADD_DOCUMENT:'Add Document',
   SUBMITTED:'Submitted',
   SUBMITTING:'Submitting...',
   VIEW_ALL_ORDERS:'View All Orders',
   CREATE_ORDER_SCHEDULES:'Create Order Schedule',
   GO_TO_HOMEPAGE:'Go to Homepage',
   DOCUMETATION:'Documentation',
   VIEW_SERVICE_REPORT:'View Service Report',
   EDIT_PROFILE:'Edit Profile',
   CREATE_LIST:'Create List',
   ADD_PARTS:'Add Parts',
   REGISTER:'Register',
   ADD_TO_MY_LIST:'Add to My List',
   ADD_TO_CART:'Add To Cart',
   CREATE_NEW_LISTS:'Create New List',
   CREATE_NEW_RECOMMENDATION_LISTS:'Create New Recommendation List',
   RESET_PASSWORD:'Reset Password',
   RESETTING_PASSWORD:'Resetting...',
   SENDING_RESET_LINK:'Sending...',
   SAVE:'Save',
   OPEN_3D_MODEL:'Open 3d Model',
   ADDING:'Adding...',
   ADDED:'Added',
   SAVE_FOR_LATER:'Save for Later',
   ADD_TO_REQUEST_LIST:'Add to Request List',
   ADD_TO_RECOMMENDATION:'Add to Recommendation List',
   CREATE_TICKET:'Create Ticket',
   CHECK_STATUS:'Check Status',
   PLACED:'Placed',
   PLACED_ORDER:'Place Order',
   CHECKOUT:'CHECKOUT',
   UPLOADS:'Upload',
   UPLOADING:'Uploading...',
   ASSIGN:'Assign',
   DELETE_CATEGORY:'Delete Category',
   REMOVE_FROM_CATEGORY:'Remove from Category',
   SELECT_ALL: 'Select All',
   DESELECT_ALL: 'Deselect All',
   CANCEL_EDITING: 'Cancel Editing',
   ENABLE_EDIT: 'Enable edit',
   ROLE_DETAILS: 'Role Details',
   USERS: 'Users ({{count}})',
   SUCCESS_TITLE: 'Success!',
   ROLE_UPDATED_SUCCESSFULLY: 'Role Updated Successfully!',
   ROLE_CREATED_SUCCESSFULLY: 'Role Created Successfully!',
   CONFIRM_ROLE_DELETION_TITLE: 'Confirm Role Deletion',
   CONFIRM_ROLE_DELETION_TEXT: 'Are you sure you want to delete the role "{{roleName}}"? This action cannot be undone.',
   YES_DELETE_CONFIRM: 'Yes, Delete',
   ROLE_DELETED_TITLE: 'Role Deleted',
   ROLE_DELETED_TEXT: '"{{roleName}}" has been successfully deleted.',
   ACTION_REQUIRED_TITLE: 'Action Required',
   ACTION_REQUIRED_TEXT: 'This role cannot be deleted at the moment. Please review dependencies.',
   DELETION_FAILED_TITLE: 'Deletion Failed',
   DELETION_FAILED_TEXT: 'An unexpected error occurred while deleting the role.',
  ROLE_NAME_CANNOT_BE_EMPTY: 'Role Name cannot be empty!',
	ROLE_WITH_NAME_ALREADY_EXISTS: 'Role with name "{{roleName}}" already exists!',
  ADDRESSES: 'Addresses ({{count}})',
  RSPL_CODE: 'RSPL Code',
  EDIT_PRODUCT: 'Edit Product',
  ADD_PRODUCT: 'Add Product',
  OPTIONS: 'Options',

};

export const PLACEHOLDER = {
  SEARCH_ORDERS: 'Search Orders',
  ORDER_DETAILS: 'View Order Details & Tracking Information',
  SEARCH_CUSTOMERS_LOCATION: 'Search Customers and Location',
  SEARCH_OPTIONS: 'Search options...',
  SEARCH: 'Search...',
  SEARCH_FOR_OPTIONS: 'Search for an option',
  SELECE_DATE_RANGE: 'Select Date Range',
  SEARCHS: 'Search',
  PHONE_NUMBER: 'Phone number',
  ENTER_FREIGHT_NUMBER: 'Enter Freight Number',
  ENTER_ORDER_NOTES: 'Enter Order Notes',
  SELECT_SITE: 'Select Site',
  CHANGE_CUSTOMER: 'Change Customer',
  EMAIL: 'Email',
  USERNAME_OR_EMAIL: 'Username or Email',
  PASSWORD: 'Password',
  SEARCH_MACHINES: 'Search Machines',
  SEARCH_ORDER_SCHEDULES: 'Search Order Schedules',
  SEARCH_PART: 'Search Part(s)',
  SEARCH_LIST: 'Search list',
  SEARCH_SELECTED: 'Search selected',
  ENTER_OTP: 'Enter OTP',
  SEARCH_MODELS: 'Search models...',

}

export const PAGE_TITLES = {
  getFilteredTitle: (metricTitle, t) => `${t('PAGE_TITLES.FILTERED_BY')} : ${metricTitle}`,
  getFilteredSubtitle: (filteredCount, totalCount, t) =>
    t('PAGE_TITLES.SHOWING_ORDERS', { filteredCount, totalCount }),
};


export const FALLBACK_TEXT = {
  UNKNOWN_CUSTOMER: 'Unknown Customer',
  UNKNOWN_SITES: 'Unknown Site',
};

export const TITLES = {
  CONFIRM: 'Confirm',
  NO_CART_ITEMS: 'No cart items found for the selected user.',
  RESET_USER_PASSWORD: 'Reset User Password',
  CONFIRM_DELETION: 'Confirm Deletion',
  CONFIRM_DELETE_USER: 'Delete user <b>{{name}}</b>? This will remove their data and sessions.',
  CUSTOMER_CARE_CONTACT: 'Customer Care Contact',
  NEXT_CART_CLEANUP: 'The next cart cleanup will happen on {{date}}.',
  CART_RETENTION_DAYS_INFO:'Stored carts will expire after the configured number of days.',
  CART_RETENTION_DISABLED_INFO:'When disabled, carts remain saved indefinitely until cleared.',
  NO_SETTINGS_PERMISSION:'You do not have access to any settings sections yet.',
  CONTACT_CCR: "Contact CCR",
  NEED_HELP: 'Need Help?',
  CART_RETENTION_ON:'Cart retention is enabled.',
  CART_RETENTION_OFF:'Cart retention is disabled (indefinite storage).',
  ADD_CUSTOMER: 'Add Customer',
  ON_HOLD_STATUS: 'On Hold Status',
  PAYMENT_TERMS: 'Payment Terms',
  DISCOUNT_MARKUP_PERCENT: 'Discount/Markup (%)',
  ENTER_DISCOUNT_MARKUP_PERCENTAGE: 'Enter discount/markup percentage (+ve or -ve)',
  ORDERS:'ORDERS',
  PARTS_ORDER_TEMPLATE:'Parts Order Template',
  CLOSE_CHAT  :'Close Chat',
  CLEAR_ALL_FILTERS:'Clear All Filters',
  GLOBAL_CHART_FILTERS:'Global Chart Filters',
  VIEW_DOCUMENTATION:'View Documentation',
  VIEW_ORDER_HISTORY:'View Order History',
  MACHINE_SOLD_NOTIFY:'Machine Sold Notification',
  EDIT_CUSTOMER:'Edit Customer',
  PROVISIONING_RESULTS:'Provisioning Results',
  VIEW_3D_MODEL:'View 3D Model',
  VIEW_CHANGE_PARTS_3D_MODEL:'View Change Parts 3D Model',
  PROFILE_UPDATED:'Profile Updated',
  VIEW_REQUEST_DETAILS:'View Request Details',
  SENT:'Sent',
  ADMIN:'Admin',
  ANALYTIC:'Analytics',
  ORDER_ANALYTICS:'Order Analytics',
  USER_ANALYTICS:'User Analytics',
  FORGOT_PASSWORD:'Forgot Password',
  BEST_SELLERS:'Best Sellers',
  LOGIN:'Login',
  HOME:'Home',
  PARTS:'Parts',
  TRAINING:'Training',
  DIGITAL_SOLUTIONS:'Digital Solutions',
  PREVENTIVE_MAINTENANCE_DASHBOARD:'Preventive Maintenance Dashboard',
  PREDICTIVE_MAINTENANCE_DASHBOARD:'Predictive Maintenance Dashboard',
  SUSTAINABLE_OVEN_SERVICE_DASHBOARD:'Sustainable Oven Service Dashboard',
  MACHINE_DASHBOARD:'Machine Dashboard (IXON)',
  CASES_TICKETS:'Cases (Tickets)',
  WORK_ORDERS_REPORTS:'Work Orders & Reports',
  CASE_DETAILS:'Case Details',
  ORDER_CONFIRMATION:'Order Confirmation',
  VIEW_ORDER_TRACKING_INFORMATION:'View Order Details & Tacking Information',
  ADD_ORDER_TO_SCHEDULE:'Add Order to Schedule',
  VIEW_ORDER_SCHEDULE_DETAILS:'View Order Schedule Details',
  EDIT_SCHEDULE:'Edit Schedule',
  DELETE_SCHEDULE:'Delete Schedule',
  CREATE_ORDER_SCHEDULE:'Create Order Schedule',
  REGISTER:'Register',
  COMPANY_DETAILS:'Company Details',
  USER_ROLE:'User Role',
  DELETE_ROLE:'Delete Role',
  TERMS_AND_CONDITIONS:'Terms and Conditions',
  RESET_PASSWORD:'Reset Password',
  RECOMMENDED_SPARE_PARTS_LISTS:'Recommended Spare Parts Lists (RSPL)',
  SERVICES:'Services',
  ORDER_DETAILS_1:'Order Details',
  ORDER_DETAILS_NO_DATA:'Order Details - No Data Available',
  SUPPORTS:'SUPPORT',
  CONFIRM_ACTION: 'Confirm Action',
  REVIEW_DETAILS_AND_CONTINUE: 'Review details and continue.',
  VERIFY_EMAIL:'Verify Email',
  VIEW_2D_MODEL:'View 2D Model',
  CART:'Cart',
  END_USER_LICENSE_AGREEMENT:'End User License Agreement',
  CHECKOUT:'Checkout',
  MACHINE_SERIAL: 'Machine Serial #:',
  PART_NUMBER: 'Part #',
  PART_NAME: 'Part Name',
  QTY: 'Qty',
  MACHINE_NUMBER: 'Machine #',


}
export const FORMS ={
	INVALID_DATA: "Invalid Data",
	INVALID_HEADERS: "Invalid Headers",
	MISSING_HEADERS: "Missing Headers",
	CATEGORY_NAME_IS_REQUIRED: "Category Name Is Required",
	MISSING_REQUIRED_FIELDS: "Missing Required Fields",
	SOME_REQUIRED_FIELDS_ARE_MISSING_OR_INCOMPLETE: "Some Required Fields Are Missing or Incomplete",
	PHONE_IS_REQUIRED: "Phone Is Required",
	MACHINE_NUMBER_IS_REQUIRED: "Machine Number Is Required",
	SUBJECT_IS_REQUIRED: "Subject Is Required",
	MESSAGE_IS_REQUIRED: "Message Is Required",
	CASE_TITLE_IS_REQUIRED: "Case Title Is Required",
	DESCRIPTION_IS_REQUIRED: "Description Is Required",
	CASE_TYPE_IS_REQUIRED: "Case Type Is Required",
	REQUESTER_NAME_IS_REQUIRED: "Requester Name Is Required",
	REQUESTER_EMAIL_IS_REQUIRED: "Requester Email Is Required",
	ALL_DOCUMENTS_IN_THIS_CATEGORY_ARE_ALSO_ASSIGNED_ELSEWHERE_NO_REASSIGNMENT_IS_REQUIRED: "All Documents in This Category Are Also Assigned Elsewhere No Reassignment Is Required",
	VALIDATION_ERROR: "Validation Error",
	PLEASE_FIX_THE_HIGHLIGHTED_FIELDS: "Please Fix the Highlighted Fields",
	FIRST_NAME_IS_REQUIRED: "First Name Is Required",
	LAST_NAME_IS_REQUIRED: "Last Name Is Required",
	INVALID_EMAIL_FORMAT: "Invalid Email Format",
	COMPANY_NAME_IS_REQUIRED: "Company Name Is Required",
	REGION_IS_REQUIRED: "Region Is Required",
	ROLE_IS_REQUIRED: "Role Is Required",
	STATUS_IS_REQUIRED: "Status Is Required",
	APPROVED_DOMAINS_ARE_REQUIRED: "Approved Domains Are Required",
	PASSWORD_REQUIREMENTS_NOT_MET: "Password Requirements Not Met",
	FULL_NAME_IS_REQUIRED: "Full Name Is Required",
	PHONE_NUMBER_IS_REQUIRED: "Phone Number Is Required",
	PLEASE_FIX_THE_FOLLOWING_ERRORS: "Please Fix the Following Errors",
	REQUEST_BODY_NOT_REQUIRED: "Request Body Not Required",
	CUSTOMER_NUMBER_IS_REQUIRED: "Customer Number Is Required",
	CUSTOMER_NAME_IS_REQUIRED: "Customer Name Is Required",
	PLEASE_FILL_THE_REQUIRED_FIELDS: "Please Fill the Required Fields",
	MACHINE_NUMBER_AND_NAME_ARE_REQUIRED: "Machine Number and Name Are Required",
	MACHINE_SERIAL_IS_REQUIRED: "Machine Serial Is Required",
	ADDRESS_NAME_IS_REQUIRED: "Address Name Is Required",
	SITE_NUMBER_IS_REQUIRED: "Site Number Is Required",
	CUSTOMER_IS_REQUIRED: "Customer Is Required",
	CURRENCY_CODE_IS_REQUIRED: "Currency Code Is Required",
	SITE_NAME_IS_REQUIRED: "Site Name Is Required",
	PASSWORD_WILL_BE_CLEARED_AND_STATUS_SET_TO_PENDING: "Password Will Be Cleared and Status Set to Pending",
	SEND_PASSWORD_CREATION_EMAIL: "Send Password Creation Email",
	SENT_WHEN_A_PASSWORD_RESET_IS_REQUESTED_FOR_YOUR_ACCOUNT: "Sent When a Password Reset Is Requested For Your Account",
	SENT_WHEN_YOUR_PASSWORD_IS_CHANGED: "Sent When Your Password Is Changed",
	MISSING_INFORMATION: "Missing Information",
	ALL_FIELDS_ARE_REQUIRED: "All Fields Are Required",
	PASSWORD_UPDATED_SUCCESSFULLY: "Password Updated Successfully",
	CURRENT_PASSWORD_IS_INCORRECT: "Current Password Is Incorrect",
	PHONE_NUMBER_IS_REQUIRED_1: "Phone Number Is Required",
	PASSWORD_RESET_LINK_SENT: "Password Reset Link Sent",
	PLEASE_MEET_ALL_PASSWORD_REQUIREMENTS: "Please Meet All Password Requirements",
	RESETSET_PASSWORD: "Resetset Password",
	SEND_PASSWORD_RESET_LINK_TO_USER: "Send Password Reset Link to User",
	CONFIRM_PASSWORD_MATCHES_1: "Confirm Password Matches",
	FORGOT_PASSWORD_1: "Forgot Password",
	PASSWORD_CHANGED: "Password Changed"
}
export const ORDERS ={
	SHIPPED_ORDERS: 'Shipped Orders',
	ORDER_BY_STATUS: 'Order By Status',
	ORDER_BY_PAYMENT_MODE: 'Order By Payment Mode',
	ORDER_ID: 'Order Id',
	PO_FILE: 'Po File',
	ORDERS_1: 'Orders',
	ORDERS_EXPORT: 'Orders Export',
	ORDERS: 'Orders',
	NO_BOM_PATH_AVAILABLE_1: 'No Bom Path Available',
	CLEAR_BOM_SEARCH: 'Clear Bom Search',
	EXPAND_THE_MACHINE_TO_VIEW_BOM_PARTS: 'Expand the Machine to View Bom Parts',
	I_WOULD_LIKE_TO_ORDER_A_PART_FOR_MY_MACHINE: 'I Would Like to Order a Part For My Machine',
	ORDER_PROCESSING_PLEASE_WAIT: 'Order Processing Please Wait',
	B_C_ORDERS: 'B C Orders',
	ORDER_COUNT: 'Order Count',
	NONORDERABLE_PART: 'Nonorderable Part',
	NO_ORDER_SCHEDULES_FOUND_FOR_CUSTOMER_LOCATION: 'No Order Schedules found for the customer location',
	ORDER_NUMBER: 'Order Number',
	PAYMENT_MODE: 'Payment Mode',
	PO_NUMBER: 'PO Number',
	USER: 'User',
	ORDER_TOTAL: 'Order Total',
	CURRENCY: 'Currency',
	STATUS: 'Status',
	CREATED_DATE: 'Created Date',
	UPDATED_DATE: 'Updated Date',
	SITE_NUMBER: 'Site Number',
	PRODUCT_NAME: 'Product Name',
	QUANTITY: 'Quantity',
	SITE: 'Site',
	BOM_LEVEL: 'Bom Level',
	SUBASSEMBLIES_BOM: 'Subassemblies Bom',
	SENT_WHEN_YOUR_ORDER_IS_PLACED_SUCCESSFULLY: 'Sent When Your Order is Placed Successfully',
	REMINDER_TO_COMPLETE_A_PENDING_PARTS_ORDER: 'Reminder to Complete a Pending Parts Order',
	THANKYOU_FOR_PLACING_THE_ORDER: 'Thankyou for Placing the Order',
	ORDER_FAILURE: 'Order Failure',
	FAILED_TO_PLACE_ORDER: 'Failed to Place Order',
	PLEASE_TRY_TO_PLACE_THE_ORDER_AGAIN_OR_CONTACT_CCR_FOR_FURTHER_ASSISTANCE: 'Please Try to Place the Order Again or Contact Ccr for Further Assistance',
	RETRY_ORDER: 'Retry Order',
	ORDERSEXPORTALLTIMEXLSX: 'Ordersexportalltime.xlsx',
	ORDER_NOT_FOUND: 'Order Not Found',
	DETAILS_FOR_THE_SELECTED_ORDER_ARE_NOT_FOUND: 'Details For the Selected Order Are Not Found',
	ORDER_DETAILS_NA: 'Order Details N/A',
	ALL_PARTS_FROM_ORDER: 'All Parts From Order',
	UNABLE_TO_ADD_PARTS_ALL_PRODUCTS_FROM_THIS_ORDER_ARE_UNAVAILABLE: 'Unable to Add Parts All Products From This Order Are Unavailable',
	NO_ITEMS_TO_ORDER: 'No Items to Order',
	NO_ORDERABLE_PARTS: 'No Orderable Parts',
	ORDER_FAILED: 'Order Failed',
	SET_ORDER_FREQUENCY_CONFIRM: 'Set Order Frequency Confirm',
	ORDERS_2: 'Orders',
	THE_REQUESTED_WORK_ORDER_REPORT_COULD_NOT_BE_FOUND: 'The Requested Work Order Report Could Not Be Found',
	ORDERED_QTY: 'Ordered Qty',
	UNKNOWN_ORDER: 'Unknown Order',
	SEARCH_BY_ORDER_PO: 'Search By Order / Po',
	ORDER_DETAILS_1: 'Order Details',
	NEW_ORDER_PLACED: 'New Order Placed',
	ORDER_PLACED_SUCCESSFULLY: 'Order Placed Successfully',
	PART_ORDER_REMINDER: 'Part Order Reminder',
	REVIEW_PARTS_BEFORE_ADDING: 'Review parts before adding to cart or request list.',
	PURCHASABLE_PARTS_INFO: 'Only purchasable parts can be added to cart. Non-purchasable parts go to request list. Not available parts cannot be added.',
	PURCHASABLE_PARTS_ADDED_TO_CART: 'Purchasable parts added to cart',
	NON_PURCHASABLE_PARTS_ADDED_TO_REQUEST_LIST: 'Non-purchasable parts added to request list',
	NO_PURCHASABLE_PARTS_TO_ADD_TO_CART: 'No purchasable parts to add to cart',
	NO_NON_PURCHASABLE_PARTS_TO_ADD_TO_REQUEST_LIST: 'No non-purchasable parts to add to request list',
	SKIPPED_REQUEST_LIST_ITEMS: 'Skipped request list items',
	NOT_AVAILABLE_PARTS: 'Not available parts',
	QTY: 'qty',
	SELECT_PRODUCTS: 'Select Products',
	PART_DETAILS: 'Part Details',
	ORDER_DETAILS: 'Order Details',
	SET_ORDER_FREQUENCY_CONFIRM: 'Set Order Frequency & Confirm',
	NON_PURCHASABLE_PARTS_INFO: '{nonPurchasable} of {total} parts in the selected order are not purchasable.',
	ONE_PART_SELECTED: '1 part selected',
	PARTS_SELECTED: '{count} parts selected'
};

export const ERRORS ={
	UNCAUGHT_ERROR: "Uncaught Error",
	COMPONENET_STACK_TRACE_ERROR: "Componenet Stack Trace Error",
	OOPS: "Oops",
	AN_UNEXPECTED_ERROR_HAS_OCCURRED_PLEASE_TRY_AGAIN: "An Unexpected Error Has Occurred Please Try Again",
	SORRY_THERE_WAS_AN_ERROR_PROCESSING_YOUR_REQUEST: "Sorry There Was an Error Processing Your Request",
	ERROR_GENERATING_RESPONSE_PLEASE_TRY_AGAIN: "Error Generating Response Please Try Again",
	FAILED_TO_SAVE_ADDRESS: "Failed to Save Address",
	SUBMISSION_FAILED: "Submission Failed",
	FAILED_TO_SAVE_OPTIONS: "Failed to Save Options",
	FAILED_TO_UPDATE_USER_NO_USER_FOUND: "Failed to Update User No User Found",
	NETWORK_ERROR_PLEASE_CHECK_YOUR_CONNECTION_AND_TRY_AGAIN: "Network Error Please Check Your Connection and Try Again",
	EMAIL_CANNOT_BE_EMPTY: "Email Cannot Be Empty",
	FULL_NAME_CANNOT_BE_EMPTY: "Full Name Cannot Be Empty",
	PHONE_NUMBER_CANNOT_BE_EMPTY: "Phone Number Cannot Be Empty",
	MESSAGE_CANNOT_BE_EMPTY: "Message Cannot Be Empty",
	SUBJECT_CANNOT_BE_EMPTY: "Subject Cannot Be Empty",
	FAILED_TO_SAVE_CUSTOMER: "Failed to Save Customer",
	FAILED_TO_SAVE_MACHINE: "Failed to Save Machine",
	AN_ERROR_OCCURRED_WHILE_DELETING_THE_SELECTED_ROLES_PLEASE_TRY_AGAIN: "An Error Occurred While Deleting the Selected Roles Please Try Again",
	ERROR_DUPLICATING_ROLE: "Error Duplicating Role",
	ERROR_PROCESSING_REQUEST: "Error Processing Request",
	CANNOT_DELETE_THIS_ROLE: "Cannot Delete This Role",
	FAILED_TO_FETCH_CUSTOMERS: "Failed to Fetch Customers",
	FAILED_TO_FETCH_CUSTOMERS_1: "Failed to Fetch Customers",
	MACHINES_FAILED_TO_PROVISION_DUE_TO_ERRORSBR: "Machines Failed to Provision Due to Errorsbr",
	FAILED_TO_UPDATE_PROVISION: "Failed to Update Provision",
	FAILED_TO_SAVE_ADDRESS_PLEASE_TRY_AGAIN: "Failed to Save Address Please Try Again",
	FAILED_TO_DELETE_ADDRESS: "Failed to Delete Address",
	DISCOUNT_CODE_CANNOT_BE_EMPTY: "Discount Code Cannot Be Empty",
	FAILED_TO_SAVE_SITE: "Failed to Save Site",
	FAILED_TO_FETCH_DATA_FROM: "Failed to Fetch Data From",
	YOU_CANNOT_DELETE_YOUR_OWN_ACCOUNT: "You Cannot Delete Your Own Account",
	FAILED_TO_DUPLICATE_USER: "Failed to Duplicate User",
	FAILED_TO_OPEN_MODEL: "Failed to Open Model",
	FAILED_TO_FETCH_MACHINE_DATA: "Failed to Fetch Machine Data",
	AN_ERROR_OCCURRED_WHILE_FETCHING_DATA: "An Error Occurred While Fetching Data",
	FAILED_TO_CREATE_USER_NO_PRODUCT_FOUND: "Failed to Create User No Product Found",
	FAILED_TO_SAVE_PREFERENCES: "Failed to Save Preferences",
	ERROR_ADDING_TO_REQUEST_LIST: "Error Adding to Request List",
	FAILED_TO_LOAD_PRODUCT_DETAILS: "Failed to Load Product Details",
	UNABLE_TO_TRANSLATE_SELECTED_ITEMS_INTO_PRODUCTS: "Unable to Translate Selected Items Into Products",
	AN_UNEXPECTED_ERROR_OCCURRED_PLEASE_TRY_AGAIN: "An Unexpected Error Occurred Please Try Again",
	FAILED_TO_UPDATE_PRICE_MARKUP: "Failed to Update Price Markup",
	FAILED_TO_FETCH_DATA_NO_SUCCESS_FLAG: "Failed to Fetch Data No Success Flag",
	FAILED_TO_FETCH_PRODUCTS_NO_SUCCESS_FLAG: "Failed to Fetch Products No Success Flag",
	FAILED_TO_FETCH_DATA_NO_DATA_FOUND_FOR: "Failed to Fetch Data No Data Found For",
	EMAIL_CANNOT_CONTAIN_CONSECUTIVE_DOTS: "Email Cannot Contain Consecutive Dots",
	EMAIL_CANNOT_START_OR_END_WITH_A_DOT: "Email Cannot Start or End With a Dot",
	PHONE_NUMBER_CANNOT_EXCEED_10_DIGITS: "Phone Number Cannot Exceed 10 Digits",
	THESE_PARTS_CANNOT_BE_PURCHASED_DIRECTLY_DO_YOU_WANT_TO_ADD_THEM_TO_YOUR_REQUEST_LIST: "These Parts Cannot Be Purchased Directly Do You Want to Add Them to Your Request List",
	SOME_PARTS_CANNOT_BE_PURCHASED_DIRECTLY_DO_YOU_WANT_TO_ADD_THEM_TO_THE_REQUEST_LIST_AS_WELL: "Some Parts Cannot Be Purchased Directly Do You Want to Add Them to the Request List As Well",
	FAILED_TO_ADD_SELECTED_PARTS: "Failed to Add Selected Parts",
	PO_NUMBER_CANNOT_EXCEED_50_CHARACTERS: "Po Number Cannot Exceed 50 Characters",
	AN_ERROR_OCCURRED_WHILE_FETCHING_THE_REPORT_PLEASE_TRY_AGAIN_LATER: "An Error Occurred While Fetching the Report Please Try Again Later",
	UNABLE_TO_SAVE: "Unable to Save",
	CANNOT_MARK_TOUR_AS_COMPLETED_NO_USER_LOGGED_IN: "Cannot Mark Tour as Completed No User Logged In",
	FAILED_TO_MARK_PAGE_TOUR_AS_COMPLETED: "Failed to Mark Page Tour as Completed",
	FAILED_TO_UPDATE_PAGE_TOUR_STATUS: "Failed to Update Page Tour Status",
	CANNOT_RESET_TOUR_NO_USER_LOGGED_IN: "Cannot Reset Tour No User Logged In",
	FAILED_TO_RESET_TOUR: "Failed to Reset Tour",
	FAILED_TO_VERIFY_EMAIL: "Failed to Verify Email",
	UNABLE_TO_FETCH_POLICY_DATA: "Unable to Fetch Policy Data",
	FAILED_TO_VERIFY_RESOURCE: "Failed to Verify Resource"
}
export const FOOTER = {
  CONFIDENTIAL_NOTICE_BODY: "All information presented on this website, including pricing, product details, and service offerings, is the confidential and proprietary information of {{company}}. Unauthorized distribution, reproduction, or sharing of this information with third parties is strictly prohibited. By accessing this information, you agree not to disclose or provide it to any third party without prior written consent from {{company}}.",
  ALL_RIGHTS_RESERVED: "© {{year}} {{company}}. All rights reserved.",
}

export const LABELS ={
    ENABLE_SERVICES_TAB: 'Enable Services Tab',
  THEME: 'Theme',
      LANG_ENGLISH: 'English',
      PLATFORM_SETTINGS: 'Platform Settings',
      COOKIE_POLICY: 'Cookie Policy',
      AUTH_BACKDROP: 'Auth Pages Backdrop',
    HOME_BACKDROP: 'Home Page Backdrop',
SET_FOR_HOME_BACKDROP: 'Set for Home Page',
FOOTER_LOGO: 'Footer Logo',
    POLICY_EDIT_TITLE: 'Edit {{type}}',
    POLICY_CREATE_TITLE: 'Create {{type}}',
    CCR_CONTACT: 'CCR Contact',
    DESCRIPTION:'Description',
    CUSTOM :'Custom',
    DEFAULT_CURRENCY:'Default Currency',
    MINIMUM_ORDER_AMOUNT:'Minimum Order Amount',
    MAX_ORDER_QTY:'Max Qty Allowed',
    CREDIT_CARD_PAYMENTS :'CREDIT_CARD_PAYMENTS',
    ENABLE_DISCOUNT_FIELD:'Enable Discount Field',
    CREID_CARD_FEES:'Credit Card Fee (%)',
    SHIPPING_COST:'Shipping Cost',
    LEAD_TIME:'Lead Time (Days)',
    TAX_RATE:'Tax Rate (%)',
    MARKUP_PERCENT:'Markup / Discount %',
    CART_RETENTION_DAYS:'Cart Retention (Days)',
    MARKUP:'Markup',
    DISCOUNT:'Discount',
    TRACK_INVENTORY:'Track Invetory',
    BACK_ORDERS:'BackOrders',
    MFA_STATUS:'MFA Status',
    MFA_ENABLED:'MFA Enabled',
    MFA_FREQUENCY:'MFA Frequency (Days)',
    FIRST_NAME:'First Name',
    LAST_NAME:'Last Name',
    SERVICES:'Services',
    PHONE_NUMBER:'Phone Number',
    EMAIL:'Email',
    PHONE:'Phone',
    ROLE:'Role',
    REGION: 'Region',
    HOME:'Home',
    MY_MACHINES:'LABELS.My_Machines',
    DOCUMENTATION:'Documentation',
    MY_LISTS:'My Lists',
    RSPL:'LABELS.rspl',
    RECOMMENDATION:'Recommendations',
    REQUEST:'Requests',
    SAVED_FOR_LATERS:'Saved For Later',
    ANALYTIC:'Analytics',
    ORDER_ANALYTICS:'Order Analytics',
    USER_ANALYTICS:'User Analytics',
    PROFILE:'Profile',
    ADMIN:'Admin',
    SUPPORT:'Support',
    ORDER:'Orders',
    TRAINING:'Training',
    SERVICE:'Service',
    SEARCH_PARTS:'Search Parts',
    CUSTOMER_CARE_REQUESTS:'Customer Care Requests',
    TRACK_MY_ORDER:'Track My Order',
    DIGITAL_SOLUTIONS:'Digital Solutions',
    CASES_TICKETS:'Cases (Tickets)',
    WORK_ORDERS_REPORTS:'Work Orders & Reports',
    LOGOUT:'Logout',
    TRACK_ORDER:'Track Order',
    ORDER_HISTORYS:'Order History',
    MACHINE_SERIAL:'Machine Serial #:',
    PART_NUMBER:'Part #',
    PART_NAME:'Part Name',
    QTY:'Qty',
    MACHINE_NUMBER:'Machine #',
    RSPL_CODE: 'RSPL Code',
    DATA_AREA_ID: 'Data Area ID',
    SHIPPING: 'Shipping',
    TAXES: 'Taxes',
    MESSAGE:'Message',
    SUBJECT:'Subject',
    MACHINE_FORM:'Machine',
    FULL_NAME:'Full Name',
    METHOD:'Method',
    API_URL:'API URL',
    AUTHENTICATION_TYPE:'Authentication Type',
    USERNAME:'Username',
    PASSWORD:'Password',
    API_KEY:'API Key',
    TOKEN:'Token',
    END_DATE_TIME:'End Date & Time',
    START_DATE_TIME:'Start Date & Time',
    JOB_TITLE:'Job Title',
    UPLOAD_NEW_CUSTOMERS:'Upload New Customers',
    DELETE_SELECTED:'Delete Selected',
    UPLOAD_NEW_MACHINES:'Upload New Machines',
	  UPLOAD_NEW_PRODUCTS:'Upload New Products',
    MACHINE_SERIAL_NUMBER:'Machine Serial Number',
    PROVISION_DATE:'Provision Date',
    ADD_NEW_PROVISION:'Add New Provision',
    POLICY_CENTER:'Policy Center',
    POLICY:'Policy',
    EXTERNAL_URL:'External URL',
    EFFECTIVE_DATE:'Effective Date',
    SORT_ORDER:'Sort Order',
    UPLOAD_FILE:'Upload File',
    ACTIVE_VERSION:'Active Version',
    CUSTOMER_VIEW_LOCATIONS:'Select a customer to view locations',
    NO_SITES_FOUND_CUSTOMER:'No Sites Found for Customer',
    LOADING:'Loading...',
    SELECT_CUSTOMER_SITE:'Select Bakery Location',
    SELECT_A_CUSTOMER:'Select a customer',
    SELECT_MACHINE:'Select Machine',
    SITE_NAME:'Site Name',
    UPLOAD_NEW_SITES:'Upload New Sites',
    ORDER_PLACED:'Order Placed',
    ORDER_CONFIRMED:'Order confirmed',
    ORDER_SHIPPED:'Order Shipped',
    ORDER_DELIVERED:'Order Delivered',
    INVOICED:'Invoiced',
    CURRENT_PASSWORD:'Current Password',
    NEW_PASSWORD:'New Password',
    CONFIRM_NEW_PASSWORD:'Confirm New Password',
    DISPLAY_NAME:'Display Name',
    NAME:'Name',
    STREET:'Street',
    CITY:'City',
    STATE:'State',
    ZIP:'ZIP',
    COUNTRY:'Country',
    PAYMENT_METHOD:'Payment Method',
    FREQUENCY:'Frequency',
    NOTIFY_EVERY_TIME:'Notify every time, before order is placed',
		CREATE_USER:'Create User',
    GLOBAL_REMINDER:'Global Reminder',
    MINIMUM_PURCHASE_COUNT_THRESHOLD:'Minimum Purchase Count Threshold',
   MAXIMUM_REMINDER_COUNT:'Maximum Reminder Count',
    CUSTOMERS:'Customers',
    DOCUMENT:'LABELS.documents',
    DOCUMENTS:'Documents',
    DOCUMENT_CATEGORIES:'Document Categories',
    RSPL:'RSPL',
    ORDER_HISTORIES:'LABELS.order_histories',
    CATEGORY:'Category',
    NEW_CATEGORY:'New Category',
   ASSIGNED_TO_MACHINES:'Assign to Machines',
    DOCUMENT_DESCRIPTION:'Document Description',
    DOCUMENT_URL:'Document URL',
    CATEGORY_NAME:'Category Name',
    WAREHOUSE:'Warehouse',
    SITE:'Site',
    SITE_CURRENCY:'Site Currency',
    DEFAULT_LEGAL_ENTITIES:'Default Legal Entity',
    ORDER_SCHEDULES:'Order Schedules',
    PRODUCT_TYPE:'productType',
    MY_INFO:'My Info',
    UPDATE_PASSWORDS:'Update Password',
    ADDRESS:'Address',
    LIST_NAME :'List Name',
    LIST_DESCRIPTION:'List Description',
    CONFIRM_PASSWORD:'Confirm Password',
    COMPANY_NAME:'Company Name',
    STREET_ADDRESS:'Street Address',
    SELECT_ROLE:'Select Role',
    ROLE_CONFIRMATION:'I confirm that the role I have selected is reflective of the rights and authorization I hold within my company',
    PURCHASER_CONFIRMATION:'I confirm that as a purchaser, I have the authority to place purchase orders on behalf of my company which creates binding contractual agreements',
    REMOVE_SELECTED:'Remove Selected',
    ADD_TO_CART:'Add to Cart',
    REQUEST_LIST:'Request List',
    AVAILABLE_TO_PURCHASE:'Available to Purchase',
    History:'History',
   SELECT_LIST :'Select List',
   MOVE_TO_CART:'Move To Cart',
	 REMOVE:'Remove',
   CREATE_NEW_CASE:'Create New Case',
   CREATE_NEW_WORKORDER:'Create New WorkOrder',
   CASES:'Cases',
   WORK_ORDERS:'Work Orders',
   ADD_DOCUMENTS:'Add Document',
   UNIT:'Unit',
   NUMBER:'Number',
	 PRIVACY_POLICY:'Privacy Policy',
   EULA:'EULA',
   MANUAL:'Manual',
   VERSION:'Version',
   RSPL:'RSPL',
   MACHINESS:'My Machines',
   EULA_AGREEMENT:'I have read and agree to the End User License Agreement (EULA)',
   ACCEPT:'Accept',
   ORDERS:'ORDERS',
   ADD_NEW_MODEL:'Add New Model' ,
   IS_CHANGE_PART:'Is Change Part',
   ADD_ALL_CRITICAL_PARTS:'Add All Critical Parts',
   ADD_ALL_MAINTENANCE_PARTS:'Add All Maintenance Parts',
   PARTS_ORDER_TEMPLATE:'Parts Order Template',
   ADD_CATEGORY:'Add Category',
  CART_RETENTION_ON:'Cart retention is enabled.',
  CART_RETENTION_OFF:'Cart retention is disabled (indefinite storage).',
  CART_RETENTION_DAYS_INFO:'Stored carts will expire after the configured number of days.',
  CART_RETENTION_DISABLED_INFO:'When disabled, carts remain saved indefinitely until cleared.',
  NO_SETTINGS_PERMISSION:'You do not have access to any settings sections yet.',
  CONTACT_CCR: "Contact CCR",
  NEED_HELP: 'Need Help?',
  BASIC_INFORMATION: 'Basic Company Information',
  LOGOS: 'Branding & Logos',
  BACKDROPS: 'Backdrops',
  STOCK_IMAGE: 'Stock Image',
  COMPANY_ADDRESS: 'Company Address',
  SOCIAL_LINKS: 'Social Links',
  FACEBOOK_URL: 'Facebook URL',
  LINKEDIN_URL: 'LinkedIn URL',
  X_TWITTER_URL: 'X (Twitter) URL',
  YOUTUBE_URL: 'YouTube URL',
  PRIMARY_LOGO: 'Logo principal',
  BROWSER_ICON: 'Browser Icon',
  AVAILABLE_LOGOS: 'Available Logos',
  UPLOAD_LOGO: 'Upload Logo',
  DEFAULT_LOGO: 'Default Logo',
  DEFAULT_SUBLOGO: 'Default Sublogo',
  SET_ACTIVE: 'Set Active',
  BACKDROP_USAGE: 'Backdrop Usage',
  DEFAULT_HOME_BACKDROP: 'Default Home Backdrop',
  DEFAULT_AUTH_BACKDROP: 'Default Auth Backdrop',
  SELECT_BACKDROP: 'Select Backdrop',
  UPLOAD_BACKDROP: 'Upload Backdrop',
  CHOOSE_BACKDROP_TYPE: 'Choose Backdrop Type',
  SET_THIS_IMAGE_AS_THE_AUTH_PAGES_OR_HOME_PAGE_BACKDROP: 'Set this image as the Auth Pages or Home Page backdrop.',
  SET_FOR_AUTH_PAGES: 'Set for Auth Pages',
  SET_FOR_HOME_PAGES: 'Set for Home Pages',
  CLEAR_AUTH_BACKDROP: 'Clear Auth Backdrop',
  CLEAR_HOME_BACKDROP: 'Clear Home Backdrop',
  BACKDROP_UPDATED_SUCCESSFULLY: 'Backdrop updated successfully',
  ACTIVE_STOCK_IMAGE: 'Active Stock Image',
  CHANGE_STOCK_IMAGE: 'Change Stock Image',
  AVAILABLE_STOCK_IMAGES: 'Available Stock Images',
  UPLOAD_STOCK_IMAGE: 'Upload Stock Image',
  UPLOAD_A_JPG_OR_PNG_UP_TO_5_MB_FOR_THE_DEFAULT_STOCK_IMAGE: 'Upload a JPG or PNG up to 5 MB for the default stock image.',
  HEADER_AND_BUTTON_FONT: 'Header & Button Font',
  BODY_TYPOGRAPHY: 'Body Typography',
  CHOOSE_FONT: 'Choose Font',
  CHOOSE_WEIGHT: 'Choose Weight',
  COLOR_PREVIEW: 'Color Preview',
  OR: 'Or',
  ENTER_A_HEX_VALUE_TO_SET_A_CUSTOM_ACCENT_COLOR: 'Enter a hex value to set a custom accent color.',
  FEATURE_TOGGLES: 'Feature Toggles',
  ENABLE_TOURS: 'Enable Tours',
  ENABLE_CHATBOT: 'Enable Chatbot',
  ENABLE_LANGUAGE_TRANSLATION: 'Enable Language Translation',
  DEFAULT_LANGUAGE: 'Default Language',
  SHOW_PRICES_ALL_ORDERS: 'Show prices for all orders',
  SHOW_PRICES_PAST_ORDERS: 'Show prices for past orders',
  ENABLE_ORDER_SCHEDULES: 'Enable order schedules across Recommendations, Checkout, and Order History',
  ENABLE_CHECKOUT_ADDRESS_EDITING: 'Enable address editing on checkout and customer locations',
  ORDER_STATUS_LABELS: 'Order Status Labels (comma separated)',
  BACKEND_STATUS: 'Backend Status',
  FRONTEND_STATUS_LABEL: 'Frontend Label',
  SHOW_IN_TRACKER: 'Show',
  ENGLISH: 'English',
  FOOTER_LINKS: 'Footer Links',
  SITE_SELECTION_SETTINGS: 'Site Selection Settings',
  ENABLE_CUSTOMER_GROUPING_IN_SITE_SELECTION: 'Enable customer grouping in site selection',
  SHOW_CUSTOMER_SITE_NUMBER_IN_SITE_SELECTION: 'Show Bakery Location Number in location selection',
  RSPL_SETTINGS: 'RSPL Settings',
  KEY: 'Key',
  VALUE: 'Value',
  SETTINGS_UPDATED_SUCCESSFULLY: 'Settings updated successfully',
  MODEL_3D_SETTINGS: '3D Model Settings',
  DEFAULT_MODEL_ORIENTATION: 'Default Model Orientation',
  LIGHT_INTENSITY: 'Light Intensity',
  HIGHLIGHT_COLOR: 'Highlight Color',
  ENTER_A_HEX_VALUE_TO_SET_A_CUSTOM_ACCENT_COLOR: 'Enter a hex value to set a custom accent color.',
  MENU_TAB_TITLES: 'Menu Tab Titles',
  SUB_ASSEMBLIES_TAB: 'Sub-Assemblies Tab',
  RSPL_PARTS_TAB: 'RSPL Parts Tab',
  PARTS_TREE_TAB: 'Parts Tree Tab',
  SHOW_TAB_SUBTITLES: 'Show tab subtitles',
  CUSTOMER_LOCATION_SETTINGS: 'Customer Location Settings',
  ENABLE_THE_SERVICES_TAB_AND_MANAGE_AVAILABLE_SERVICES: 'Enable the Services tab and manage available services.',
  LABEL: 'Label',
  DESCRIPTION: 'Description',
  URL: 'URL',
  LOCATION_OPTIONS: 'Location Options',
  SHOW_DEFAULT_LEGAL_ENTITY: 'Show Default Legal Entity',
  SHOW_SITE: 'Show Site',
  SHOW_WAREHOUSE: 'Show Warehouse',
  SHOW_PAYMENT_TERMS: 'Show Payment Terms',
  SHOW_ON_HOLD_STATUS: 'Show On Hold Status',
  EMERGENCY_CONTACTS_BY_REGION: 'Emergency Contacts by Region',
  CONFIGURE_THE_EMERGENCY_CONTACT_NUMBER_USED_IN_THE_CONTACT_CCR_FORM_FOR_EACH_REGION: 'Configure the emergency contact number used in the Contact CCR form for each region.',
  ADMIN_MODULE_AVAILABILITY: 'Admin Module Availability',
  PORTAL_FRONTEND: 'Portal (Frontend)',
  API_BACKEND: 'API (Backend)',
  CREATE_A_NEW_ROLE: 'Create a New Role',
  NEW_ADDRESS: 'New Address',
  SERVICE_PLAN: 'Service Plan',
  AMFMETHOD_PREMIUM: 'AMFPremium',
  SUSTAINABLE_OVEN_SERVICE: 'Sustainable Oven Service',
  MACHINE_DASHBOARD_IXON: 'Machine Dashboard (IXON)',
  PREDICTIVE_MAINTENANCE: 'Predictive Maintenance'
};

export const DATE_RANGES = {
  TODAY: 'TODAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
  QUARTER: 'QUARTER',
  YEAR: 'YEAR',
  ORDERS: 'Orders',
  QUERY_RETURNED_NO_DATA: 'No results found for the selected filters'

};

export const MENU_ITEMS = {
    ENABLED:'Enabled',
    DISABLED:'Disabled',
    ADMIN:'Admin',
    VIEWER:'Viewer',
    PURCHASER:'Purchaser',
    APPROVED:'Approved',
    PENDING:'Pending',
    SHIPPED:'Shipped',
    CONFIRMED:'Confirmed',
    NONE:'None',
    BEARER_TOKEN:'Bearer Token',
    BASIC_AUTH:'Basic Auth',
    OAUTH:'OAuth 2.0',
    API_KEYS:'API Key',
    GET:'GET',
    POST:'POST',
    PUT:'PUT',
    DELETE:'DELETE',
    EVERY_MINUTE:'Every Minute',
    EVERY_15_MINUTES:'Every 15 Minutes',
    EVERY_HOUR:'Every Hour',
    EVERY_THREE_HOURS:'Every 3 Hours',
    EVERY_SIX_HOURS:'Every 6 Hours',
    EVERY_TWELVE_HOURS:'Every 12 Hours',
    EVERY_DAY_START_TIME:'Every Day at Start Time',
    EVERY_MONTH_START_TIME:'Every Month at Start Time',
    ACTIVE:'Active',
    INACTIVE:'Inactive',
    PREPAID_AND_ADD:'Prepaid and Add',
    COLLECT_DELIVERY:'Collect',
    YES:'Yes',
    NO:'NO',
    UPS_GROUND:'UPS Ground',
    UPS_NEXT_DAY_AIR:'UPS Next Day Air',
    FEDEX_GROUND:'FedEx Ground',
    CREDIT_DEBIT_CARDS:'Credit / Debit Cards',
    NO_SITES_AVAILABLES:'-- No Sites Available --',
    NO_USERS_AVAILABLES:'-- No Users Available --',
    ALL:'All',
    NO_MACHINES_AVAILABLES:'-- No Machines Available --',
    CREATE_NEW_CATEGORY:'+ Create New Category',
    CREATE_NEW_LIST:'--- Create New List ---',
    DAILY:'Daily',
    WEEKLY:'Weekly',
    MONTHLY:'Monthly',
    QUARTERLY:'Quarterly',
    YEARLY:'Yearly',
    DAYS:'Days',
    MONTHS:'Months',


}

export const DIVIDER = {
  USER_DETAILS: 'User Details',
  CUSTOMER_ALLOCATION: 'Customer Allocation',
}



export const ALERT_MESSAGES = {
  NO_DETAILS_FOUND_FOR_SUBMISSION: 'No details found for this submission.',
  OPTION_SAVED_SUCCESSFULLY: 'Option saved successfully',
  WARNING: 'Warning',
  UNAUTHORIZED_ACTION: 'Unauthorized Action',
  DEFAULT_ROLE_DELETE_WARNING: 'Default roles cannot be deleted.',
  PRODUCT_UPDATED_SUCCESSFULLY: 'Product updated successfully.',
  PRODUCT_CREATED_SUCCESSFULLY: 'Product created successfully.',
  EMAIL_IS_REQUIRED: 'Email is required',
  WARNING_TITLE: 'Warning!',
  INVALID_FILE_TYPE_TITLE: 'Invalid File Type',
  INVALID_FILE_TYPE_TEXT: 'Please upload a PDF, JPG, or PNG file.',
  CHARACTERS_COUNT: 'characters',
  FILE_TOO_LARGE_TITLE: 'File Too Large',
  FILE_TOO_LARGE_TEXT: 'The file size cannot exceed 5MB. Please choose a smaller file.',
  NO_PRODUCTS_FOR_MACHINE: 'No Products available for Machine',
  ERROR: 'Error!',
  FAILED_DATA: 'Failed to fetch data.',
  MACHINE_NOT_FOUND: 'Machine Not Found',
  CUSTOMER_CARE_CONTACT_SHORTLY: 'A Customer Care representative will be in contact with you shortly!',
  SUCCESS: 'Success',
  PLEASE_TRY_AGAIN: 'Something went wrong while provisioning the machine. Please try again.',
  SUCCFULLY_MESSAGE: 'Sucessfully deleted the Provisions',
  NO_HISTORY_AVAILABLE: 'No History Available',
  ERROR_FETCHING_HISTORY: 'Error Fetching History',
  FAILED_TO_PASSWORD_LINK: 'Failed to sent password reset link. Please try again.',
  PLEASE_SELECT_USER_TO_DELETE: 'Please select users to delete.',
  NO_USERS_SELECTED: 'No Users Selected',
  ARE_YOU_SURE: 'Are you sure?',
  DELETE_SELECTED_USERS: 'You are about to delete selected users. This action cannot be undone!',
  USERS_DELETED: 'Users Deleted',
  INVALID_FILE_STRUCTURE: 'Invalid File Structure',
  NOT_REQUIRED_HEADER: 'The uploaded file does not have the required headers.',
  PROVISIONING_RESULTS: 'Provisioning Results',
  CART_MESSAGE: 'Your cart is empty. Continue shopping to add items to your cart.',
  FAILED_TO_DOWNLOAD_FILE_PLEASE_TRY_AGAING: 'Failed to download file. Please try again.',
  NO_MACHINES_FOUND_FOR_THE_SELECTED_SITE: 'No Machines Found for the selected Site',
  NO_MACHINES_FOUND: 'No machines found.',
  THIS_WILL_DELETE_SCHEDULE_PERMANENTLY: 'This will delete this schedule permanently.',
  NO_PRODUCTS_FOUND_MACHINE: 'No Products Found for the selected Machine',
  NO_PRODUCT_REQUEST_LIST: 'No Products in the Request List',
  NO_PRODUCT_AVAILABLE_TO_PURCHASE: 'No Products Available to Purchase',
  NO_PRODUCTS_FOR_SELECTED_MACHINE: 'No products for selected machine',
  NO_PRODUCTS_IN_SAVED_LATER: 'No Products in Saved for Later',
  NO_CASES_FOUND: 'No Cases Found',
  NO_WORKORDERS_FOUND: 'No Work Orders Found',
  NO_DOCUMENTS_ASSIGENED: 'No Documents assigned to this machine',
  NO_DOCUMENT_IN_CATEGORY: 'No Documents in Category',
  UNABLE_TO_OPEN_DOCUMENT: 'Unable to open the document. Please try again later.',
  NO_PARTS_FOUND: 'No Parts Found',
  SELECT_USER_DELETE_SUCCESSFULLY: 'Selected users have been deleted successfully.',
  FAILED_DELETE_USER: 'Failed to delete users. Please try again.',
  DELETE_USERS_FAILED: 'errors.delete_users_failed',
  SETTINGS_UPDATED:'Settings Updated',
  GLOBAL_REMINDER_SETTING_UPDATED:'Global reminder settings updated successfully.',
  CONTACT_ADMIN_FOR_PASSWORD_RESET:'Please contact your system administrator to reset the password.',
  ACCOUNT_PENDING_APPROVAL:'Your account is pending approval. Contact your administrator.',
  NO_PRODUCTS_SELECTED: 'No Products Selected',
  INVALID_OR_MISSING_TOKEN:'Invalid or missing token.',
  PASSWORD_RESET_SUCCESS:'Password has been reset.',
  RESET_PASSWORD_FAILED:'An error occurred while resetting the password.',
  RESET_PASSWORD_GENERIC_ERROR:'Error resetting password. Please try again.',
  MODEL_OPEN_FAILED:'Failed to open the requested model. Please try again later.',
  SELECT_REGION_AND_COUNTRY:'Please select Region and Country.',
  AGREE_TO_ALL_PURCHASER_TERMS:'Please agree to all purchaser terms and conditions.',
  FAILED_UPDATE_GLOBAL_REMINDER:'Failed to update global reminder settings.',
  FAILED_SETTINGS_FOR_GLOBAL:'errors.failed_settings_for_global',
  JOB_CREATED:'Job has been created successfully.',
  SCHEDULE_SET_SUCCESSFULLY: 'Schedule set successfully!',
  SCHEDULE_UPDATED_SUCCESSFULLY: 'Schedule updated successfully!',
  PLEASE_FILL_REQUIRED_FIELDS:'Please fill in all required fields.',
  PLEASE_FILL_REQUIRED_FILEDS_BEFORE_SCHEDULE:'Please fill in all required fields before setting the schedule.',
  PLEASE_ADD_ONE_PRODUCT:'Please add at least one product to the order.',
  REQUIRED_FIELD_BEFORE_PROCEEDING:'Please fill in all required fields before proceeding.',
  CANNOT_COMPLETE_CHECKOUT:'Cannot Complete Checkout. Some items may not be purchasable',
  SENT:'Sent',
  FAILED_TO_SEND_PASSWORD_RESET_LINK:'Failed to send password reset link. Please try again',
  NO_ACCOUNT_FOUND:'No account was found with this email address',
  ERROR_OCCURED:'An error occurred. Please try again.',
  ERROR_OCCURED_PLEASE_TRY_AGAIN:'An error occurred. Please try again later.',
  AN_EXPECTED_ERROR:'An unexpected error occurred.',
  LOGIN_FAILED:'Login failed: Invalid response received',
  INVALID_CREDENTIALS:'Invalid email or password. Please try again.',
  REQUIRED_PASSWORD:'Password is required',
  REQUIRED_EMAIL:'Email is required',
  DELETED:'Deleted',
  DOCUMENT_DELETED_SUCCESSFULLY:'Document deleted successfully',
  COULD_NOT_DELETE_DOCUMENT:'Could not delete the document. Please try again.',
	AN_ERROR_OCCURED_UPDATING_SITE:'An error occurred while updating the site.',
  SITE_UPDATED_SUCCESSFULLY:'Site updated successfully',
  THE_SITE_META_UPDATED:'The site meta has been updated.',
  SITE_NAME_REQUIRED:'Site name is required.',
  WAREHOUSE_REQUIRED:'Warehouse is required.',
  LEGAL_ENTITY_REQUIRED:'Legal entity is required.',
  CURRENCY_REQUIRED:'Currency is required.',
  ERROR_OCCURED_FETCHING_ORDER:'An error occurred while fetching the order.',
  ERROR_OCCURED_FETCHING_PLEASE_TRY_AGAIN:'An error occurred while fetching the order. Please try again.',
  DOCUMENT_PERMANENTLY_DELETED:'This will delete the document permanently.',
  SOMETHING_WRONG_PLEASE_TRY_AGAIN:'Something went wrong. Please try again',
  DOCUMENT_UPLOADED_SUCCESSFULLY:'Document uploaded successfully',
  DUPLICATE_DOCUMENT_NAME:'Duplicate document name',
  DUPLICATE_DOCUMENT_NAME_CATEGORY:'A document with the same name and category already exists.',
  UNKNOWN_ERROR:'Unknown error',
  REMOVED:'Removed',
  PART_SUCCESSFULLY_REMOVED_LIST:'Part successfully removed from the list.',
  CATEGORY_UPDATED:'Category updated successfully',
  CATEGORY_CREATED:'Category created successfully',
  CATEGORY_DELETE_REASSIGN_REQUIRED:'Please reassign documents or choose a fallback category before deleting this category.',
  CATEGORY_DELETED:'Category deleted successfully',
  FAILED_TO_REMOVE_PART:'Failed to remove the part.',
  AN_ERROR_OCCURED_REMOVING_PART:'An error occurred while removing the part. Please try again.',
  FAILED_TO_DELETE_THE_LIST:'Failed to delete the list. Please try again',
  FAILED_TO_CREATE_THE_LIST:'Failed to Create the list. Please try again',
  USER_REGISTERED_SUCCESSFULLY:'User Registered Successfully',
  REDIRECT_LOGIN_PAGE:'You will be redirected to the login page.',
  YOU_MUST_AGREE_BOTH_TERMS:'You must agree to both terms to proceed.',
  PLEASE_ENTER_VALID_EMAIL_ADDRESS:'Please enter a valid email address',
  PASSWORDS_DO_NOT_MATCH:'Passwords do not match',
  NO_PRODUCTS_SELECTED:'No Products Selected',
  PLEASE_SELECT_PRODUCTS_NOTIFY:'Please select products to notify.',
  NOTIFIED_CUSTOMER_CARE:'Notified Customer Care',
  PLEASE_SELECE_PRODUCTS_ADD_TO_CART:'Please select products to add to cart.',
  PRODUCTS_ADD_TO_CART:'Products Added to Cart',
  FAILED_TO_REMOVE_PART_SAVED:'Failed to remove part(s) from Saved for Later.',
  PARTS_REMOVED_SAVED_LATED:'Part(s) Removed from Saved for Later',
  SELECT_PARTS_REMOVE:'Please select Part(s) to remove.',
  NO_PARTS_SELECTED:'No Part(s) Selected',
  PARTS_ADD_TO_CART:'Part(s) Added to Cart',
  NEW_RECOMMENDATION_LIST:'New Recommendation List created and Product added to list',
  PART_ADDED_TO_LIST:'Part added to list',
  INFO:'Info',
  PART_ALREADY_PRESENT_LIST:'Part already present in the list',
  PART_ALREADY_ADDED_LIST:'This part is already added to the list.',
  ERROR_CREATING_LIST:'Error creating list',
  ERROR_ADDING_TO_LIST:'Error Adding to List',
  SOME_PART_CAN_NOT_BE_PURCHASED:'Some of the Selected Part(s) Cannot be Purchased. Do you want to add them to Requests?',
  PLEASE_SELECT_FILE:'Please select a file and try again.',
  ONLY_ONE_FILE_UPLOAD:'Only one file can be uploaded for a Change Part.',
  MODEL_FILE_UPLOAD_SUCCESSFULLY:'Model file(s) uploaded successfully.',
  FAILED_MODEL_UPLOAD_FILE:'Failed to upload model file(s). Please try again.',
  FILE_DELETED_SUCCESSFULLY:'File deleted successfully.',
  FAILED_TO_DELETE_FILE:'Failed to delete file.',
  ERROR_DELETING_FILE:'Error deleting file.',
  FILE_REPLACED_SUCCESSFULLY:'File replaced successfully.',
  FAILED_TO_REPLACE:'Failed to replace file.',
  ERROR_REPLACING_FILE:'Error replacing file.',
  ERROR_OCCURED_PLACING_ORDER:'An error occurred while placing the order. Please try again.',
  ERROR_OCCURED_WHILE_PLACING:'An error occurred while placing the order.',




};

export const METRICS = {
  TOTAL_EARNINGS: 'Total Earnings',
  TOTAL_ORDERS: 'Total Orders',
  PENDING_ORDERS: 'Pending Orders',
  INVOICE_ORDERS: 'Invoiced Orders',
  DELIVERED_ORDERS: 'Delivered Orders',
  AVERAGE_ORDER_VALUE: 'Average Order Value'

};

export const COMPANY = {
  COMPANY_EMAIL: 'Company Email',
  FOOTER_1: 'Footer',
  ICON: 'Icon',
  DOC_ICON: 'Doc Icon',
  I_AGREE_TO_FOLLOW_COMPANY_PROCUREMENT_POLICIES: 'I Agree to Follow Company Procurement Policies',
  I_CONFIRM_I_AM_AUTHORIZED_TO_PLACE_PURCHASE_REQUESTS: 'I confirm I am authorized to place purchase requests.'
};

export const MESSAGES = {
  CUSTOM_REPEAT_ORDER: 'orders.custom_repeat_order',
  STANDARD_REPEAT_ORDER: 'orders.standard_repeat_order',
};

export const TOURS = {
  WELCOME_TO_B2B_ECOMMERCE_ADMIN_SECTION: 'Welcome to B2B E-Commerce Admin Section',
  ADMIN_COMPREHENSIVE_CONTROL: 'As an Admin, you have comprehensive control to manage users, sites, documents, and machine provisionings, and other details for the portal.',
  ADMIN_NAVIGATION: 'Admin Navigation',
  KEY_CONSOLE: 'Key Console',
  ADMIN_ASSIGNING_SPECIFIC_LOCATIONS: 'Note: You are assigning specific locations to an Admin. Without allocations, Admins have access to all locations.',
  ADMIN_ALLOCATE_SPECIFIC_LOCATIONS: 'Note: Admins have access to all customer locations. Use "Allocate specific locations" to restrict if needed.',
  MULTIPLE_CUSTOMERS_MULTIPLE_LOCATIONS: 'Note: Multiple customers and multiple locations per customer are allowed for this role.',
  MULTIPLE_CUSTOMERS_ONE_LOCATION: 'Note: Multiple customers are allowed; only one location per customer.',
  ONE_CUSTOMER_MULTIPLE_LOCATIONS: 'Note: Only one customer is allowed; multiple locations within that customer are allowed.',
  ONE_CUSTOMER_ONE_LOCATION: 'Note: Only one customer and one location are allowed for this role.',
  WELCOME_TO_B2B_ECOMMERCE: 'Welcome to B2B E-Commerce',
  THIS_APPLICATION_ALLOWS_YOU_TO_VIEW_MACHINES_AND_THEIR_PARTS_MANAGE_RECOMMENDED_SPARE_PARTS_LISTS_RSPL_MANAGE_WISHLISTS_PLACE_AND_TRACK_ORDERS_FOR_AN_END_TO_END_MACHINE_PART_ORDERING_EXPERIENCE: 'This application allows you to view machines and their parts, manage Recommended Spare Parts Lists (RSPL), manage wishlists, place and track orders for an end-to-end machine part ordering experience.',
  MAIN_NAVIGATION: 'Main Navigation',
  ACCESS_KEY_SECTIONS_LIKE_HOME_MY_MACHINES_DOCUMENTATION_MY_LISTS_RSPL_RECOMMENDATIONS_REQUESTS_SAVED_FOR_LATER_AND_ANALYTICS_FROM_THE_NAVIGATION_BAR: 'Access key sections like <strong>Home</strong>, <strong>My Machines</strong>, <strong>Documentation</strong>, <strong>My Lists</strong> (RSPL, Recommendations, Requests, Saved for Later), and <strong>Analytics</strong> from the navigation bar.',
  HEADER_TOOLS: 'Header Tools',
  THE_HEADER_TOOL_BAR_PROVIDES_QUICK_ACCESS_TO_YOUR_SHOPPING_CART_A_GLOBAL_SEARCH_FUNCTION_AND_THE_ABILITY_TO_VIEW_CHANGE_YOUR_CURRENT_SITE_YOU_CAN_ALSO_VIEW_NOTIFICATIONS_AND_MANAGE_YOUR_PROFILE_THE_PROFILE_ICON_ALSO_PROVIDES_ACCESS_TO_ADMIN_SECTION_SUPPORT_AND_ORDER_HISTORY: 'The header tool bar provides quick access to your <strong>Shopping Cart</strong>, a global <strong>Search</strong> function, and the ability to view/change your current <strong>Site</strong>. You can also view notifications and manage your Profile. The Profile icon also provides access to Admin Section, Support, and Order History.',
  GLOBAL_SEARCH: 'Global Search',
  USE_THIS_SEARCH_BAR_TO_QUICKLY_FIND_PARTS_MACHINES_AND_PAGES_BY_ENTERING_KEYWORDS: 'Use this search bar to quickly find parts, machines, and pages by entering keywords.',
  QUICK_ACCESS_PANELS: 'Quick Access Panels',
  NAVIGATE_DIRECTLY_TO_KEY_SECTIONS_MY_MACHINES_DOCUMENTS_RSPL_AND_ORDER_HISTORY: 'Navigate directly to key sections: <strong>My Machines</strong>, <strong>Documents</strong>, <strong>RSPL</strong>, and <strong>Order History</strong>.',
  FOOTER_INFORMATION: 'Footer Information',
  THE_FOOTER_CONTAINS_CONTACT_US_INFORMATION_QUICK_LINKS_HOME_MY_MACHINES_RSPL_RECOMMENDATIONS_AND_LEGAL_DOCUMENTS_PRIVACY_POLICY_EULA: 'The footer contains <strong>Contact Us</strong> information, <strong>Quick Links</strong> (Home, My Machines, RSPL, Recommendations), and <strong>Legal</strong> documents (Privacy Policy, EULA).'
};

export const BUTTONS = {
    NEXT: 'Next',
    BACK: 'Back',
    FINISH: 'Finish',
    CANCEL: 'Cancel',
    ADD_TO_CART: 'Add to Cart',
    ADD_TO_CART_AND_REQUEST_LIST: 'Add to Cart & Request List',
    ADD_TO_REQUEST_LIST: 'Add to Request List'
}
